<template>
  <div class="fin-reg-rec-des">
    <!-- APRESENTA A OPÇÃO CARREGANDO NA TELA -->
    <RF-Status v-if='statusGeral !== ""' :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    
    <!-- APRESENTA O CONTEUDO DA TELA -->
    <template v-else>
      <!-- PARCELAS -->
      <div class="parcelas noselect">
        <!-- SETA O TITULO -->
        <div v-if="cpntTipo !== 'pgto_docfiscal' && cpntDemandaDados !== null">Registrar parcelas no financeiro</div>
        
        <!-- SETA O NUMERO DE PARCELAS -->
        <div class="seletor">
          <!-- FRASE -->
          <div>Nº de parcelas:</div>

          <!-- SELETOR -->
          <App-Select :data-time="time" class="fin-reg-rec-des--parcelas"
          :cpntStatus='parcelas.status'
          :cpntId='parcelas.id'
          :class='parcelas.class'
          :cpntTabIndex='parcelas.tabIndex'
          :cpntNome='parcelas.nome'
          :cpntValue='parcelas.value'
          :cpntMensagem='parcelas.mensagem'
          :cpntMensagemTipo='parcelas.mensagemTipo'
          :cpntDisabled='parcelas.disabled'
          :cpntMostrar='parcelas.mostrar'
          :cpntExplica='parcelas.explica'
          :cpntPlaceholder='parcelas.placeholder'
          :cpntValueRef='parcelas.valueRef'
          :cpntRouter='parcelas.router'
          :cpntMethod='parcelas.method'
          :cpntField='parcelas.field'
          :cpntWhere='parcelas.where'
          :cpntAddButForm='parcelas.addButForm'
          :cpntKeyMostra='parcelas.keyMostra'
          :cpntTipoOrder='parcelas.tipoOrder'
          :cpntOrder='parcelas.order'
          :cpntOptions='parcelas.options'
          :cpntKeyValue='parcelas.keyValue'
          :cpntSearchMinimo='parcelas.searchMinimo'
          :cpntMask='parcelas.mask'
          :cpntOptionInicialNome='parcelas.optionInicialNome'
          :cpntOptionInicialValue='parcelas.optionInicialValue'
          :cpntNewOption='parcelas.newOption'
          :cpntOnChange='(value) => { finRegRecDesOnChangeValueParcela(value) }'
          ></App-Select>
        </div>
      </div>

      <!-- TABELA -->
      <App-Tabela class="tabela" :class="([ '', null, undefined, '1', 1 ].indexOf(finRegRecDesValorParcelas()) !== -1 ? 'resumido' : '') + (' fin-reg--' + cpntTipo)"
      :cpntColuna="colunas"
      :cpntLinha="linhas"
      ref="tabela">
        <template v-slot:th_valor="{ coluna }">
          <div class="titulo">
            <!-- SETA O TITULO -->
            <span v-html="coluna.nome"></span>

            <!-- SETA A EXPLICAÇÃO DO CAMPO -->
            <App-Explica :cpntTitle='"Inserindo um valor no campo referência abaixo o Rotina Fácil irá:<br/><br/>Caso selecionado <b>C = Copiar</b>: Irá copiar o valor para todas as parcelas.<br/><br/>Caso selecionado <b>D = Dividir</b>: Irá tratar o valor como um total e dividi-lo entre as parcelas."'></App-Explica>
          </div>

          <div class="mascara">
            <App-Select :data-time="time" class="fin-reg-rec-des--valor_tipo"
            :cpntStatus='campos.valor_tipo.status'
            :cpntId='cpntHash + "valor_tipo"'
            :cpntTabIndex='campos.valor_tipo.tabIndex'
            :cpntNome='campos.valor_tipo.nome'
            :cpntValue='referencia.valor_tipo'
            :cpntMensagem='campos.valor_tipo.mensagem'
            :cpntMensagemTipo='campos.valor_tipo.mensagemTipo'
            :cpntDisabled='campos.valor_tipo.disabled'
            :cpntMostrar='campos.valor_tipo.mostrar'
            :cpntExplica='campos.valor_tipo.explica'
            :cpntPlaceholder='campos.valor_tipo.placeholder'
            :cpntValueRef='campos.valor_tipo.valueRef'
            :cpntRouter='campos.valor_tipo.router'
            :cpntMethod='campos.valor_tipo.method'
            :cpntField='campos.valor_tipo.field'
            :cpntWhere='campos.valor_tipo.where'
            :cpntAddButForm='campos.valor_tipo.addButForm'
            :cpntKeyMostra='campos.valor_tipo.keyMostra'
            :cpntTipoOrder='campos.valor_tipo.tipoOrder'
            :cpntOrder='campos.valor_tipo.order'
            :cpntOptions='campos.valor_tipo.options'
            :cpntKeyValue='campos.valor_tipo.keyValue'
            :cpntSearchMinimo='campos.valor_tipo.searchMinimo'
            :cpntMask='campos.valor_tipo.mask'
            :cpntNewOption='campos.valor_tipo.newOption'
            :cpntOptionInicialNome='campos.valor_tipo.optionInicialNome'
            :cpntOptionInicialValue='campos.valor_tipo.optionInicialValue'
            :cpntOnChange='(value) => { finRegRecDesOnChangeValueReferencia(value, "valor_tipo") }'
            ></App-Select>

            <App-Input :data-time="time" class="fin-reg-rec-des--valor"
            :cpntStatus='campos.valor.status'
            :cpntId='cpntHash + "valor"'
            :class='campos.valor.class'
            :cpntTabIndex='campos.valor.tabIndex'
            :cpntClassDivField='campos.valor.classDivField'
            :cpntNome='campos.valor.nome'
            :cpntValue='referencia.valor'
            :cpntAutoComplete='campos.valor.autocomplete'
            :cpntMask='campos.valor.mask'
            :cpntOptionInicialNome='campos.valor.optionInicialNome'
            :cpntOptionInicialValue='campos.valor.optionInicialValue'
            :cpntDisabled='campos.valor.disabled'
            :cpntMostrar='campos.valor.mostrar'
            :cpntAutoFocus='campos.valor.autofocus'
            :cpntMensagem='campos.valor.mensagem'
            :cpntMensagemTipo='campos.valor.mensagemTipo'
            :cpntPlaceholder='campos.valor.placeholder'
            :cpntPosicionar='campos.valor.posicionar'
            :cpntOnChange='(value) => { finRegRecDesOnChangeValueReferencia(value, "valor") }'
            ></App-Input>
          </div>
        </template>

        <template v-slot:th_vencimento="{ coluna }">
          <template v-if="finRegRecDesValorParcelas() > 1 && (cpntTipo !== 'pgto_docfiscal' || ([ '03', '3' ].indexOf(referencia.id_pgto.id) !== -1 || linhas.filter(item => [ '03', '3' ].indexOf(item.id_pgto.id) !== -1).length >= 1))">
            <div class="titulo">
              <!-- SETA O TITULO -->
              <span v-html="coluna.nome"></span>

              <!-- SETA A EXPLICAÇÃO DO CAMPO -->
              <App-Explica :cpntTitle='"Recurso para cálculo automático de datas. Para utilizá-lo deixar uma data preenchida no campo referência abaixo.<br/><br/>Caso selecionado <b>S = Somar</b>: Para o campo numérico digite o número de dias que deseja adicionar a data de vencimento.<br/><br/>Caso selecionado <b>D = Fixar dia</b>: O dia digitado abaixo será fixado para todos os campos de data porém o mês será incrementado a cada parcela.<br/><br/>Caso selecionado <b>C = Copiar</b>: A data digitada abaixo será copiada para todos os campos."'></App-Explica>
            </div>
            
            <div class="mascara" v-if="cpntTipo !== 'pgto_docfiscal' || ([ '03', '3' ].indexOf(referencia.id_pgto.id) !== -1 || linhas.filter(item => [ '03', '3' ].indexOf(item.id_pgto.id) !== -1).length >= 1)">
              <App-Select :data-time="time" class="fin-reg-rec-des--vcto_tipo"
              :cpntStatus='campos.vcto_tipo.status'
              :cpntId='cpntHash + "vcto_tipo"'
              :cpntTabIndex='campos.vcto_tipo.tabIndex'
              :cpntNome='campos.vcto_tipo.nome'
              :cpntValue='referencia.vcto_tipo'
              :cpntMensagem='campos.vcto_tipo.mensagem'
              :cpntMensagemTipo='campos.vcto_tipo.mensagemTipo'
              :cpntDisabled='campos.vcto_tipo.disabled'
              :cpntMostrar='campos.vcto_tipo.mostrar'
              :cpntExplica='campos.vcto_tipo.explica'
              :cpntPlaceholder='campos.vcto_tipo.placeholder'
              :cpntValueRef='campos.vcto_tipo.valueRef'
              :cpntRouter='campos.vcto_tipo.router'
              :cpntMethod='campos.vcto_tipo.method'
              :cpntField='campos.vcto_tipo.field'
              :cpntWhere='campos.vcto_tipo.where'
              :cpntAddButForm='campos.vcto_tipo.addButForm'
              :cpntKeyMostra='campos.vcto_tipo.keyMostra'
              :cpntTipoOrder='campos.vcto_tipo.tipoOrder'
              :cpntOrder='campos.vcto_tipo.order'
              :cpntOptions='campos.vcto_tipo.options'
              :cpntKeyValue='campos.vcto_tipo.keyValue'
              :cpntSearchMinimo='campos.vcto_tipo.searchMinimo'
              :cpntMask='campos.vcto_tipo.mask'
              :cpntNewOption='campos.vcto_tipo.newOption'
              :cpntOptionInicialNome='campos.vcto_tipo.optionInicialNome'
              :cpntOptionInicialValue='campos.vcto_tipo.optionInicialValue'
              :cpntOnChange='(value) => { finRegRecDesOnChangeValueReferencia(value, "vcto_tipo") }'
              ></App-Select>

              <App-Input :data-time="time" class="fin-reg-rec-des--vcto_soma" :style="finRegRecDesPegarValorReferencia('vcto_tipo') === 'S' ? '' : 'visibility: hidden;'"
              :cpntStatus='campos.vcto_soma.status'
              :cpntId='cpntHash + "vcto_soma"'
              :class='campos.vcto_soma.class'
              :cpntTabIndex='campos.vcto_soma.tabIndex'
              :cpntClassDivField='campos.vcto_soma.classDivField'
              :cpntNome='campos.vcto_soma.nome'
              :cpntValue='referencia.vcto_soma'
              :cpntAutoComplete='campos.vcto_soma.autocomplete'
              :cpntMask='campos.vcto_soma.mask'
              :cpntOptionInicialNome='campos.vcto_soma.optionInicialNome'
              :cpntOptionInicialValue='campos.vcto_soma.optionInicialValue'
              :cpntDisabled='campos.vcto_soma.disabled'
              :cpntMostrar='campos.vcto_soma.mostrar'
              :cpntAutoFocus='campos.vcto_soma.autofocus'
              :cpntMensagem='campos.vcto_soma.mensagem'
              :cpntMensagemTipo='campos.vcto_soma.mensagemTipo'
              :cpntPlaceholder='campos.vcto_soma.placeholder'
              :cpntPosicionar='campos.vcto_soma.posicionar'
              :cpntOnChange='(value) => { finRegRecDesOnChangeValueReferencia(value, "vcto_soma") }'
              ></App-Input>

              <App-Calendario :data-time="time" class="fin-reg-rec-des--vcto_pgto"
              :cpntStatus='campos.vcto_pgto.status'
              :cpntId='cpntHash + "vcto_pgto"'
              :cpntClassDivField='campos.vcto_pgto.classDivField'
              :cpntNome='campos.vcto_pgto.nome'
              :cpntValue='referencia.vcto_pgto'
              :cpntAutoComplete='campos.vcto_pgto.autocomplete'
              :cpntMask='campos.vcto_pgto.mask'
              :cpntDisabled='campos.vcto_pgto.disabled'
              :cpntMostrar='campos.vcto_pgto.mostrar'
              :cpntAutoFocus='campos.vcto_pgto.autofocus'
              :cpntMensagem='campos.vcto_pgto.mensagem'
              :cpntMensagemTipo='campos.vcto_pgto.mensagemTipo'
              :cpntPlaceholder='campos.vcto_pgto.placeholder'
              :cpntExplica='campos.vcto_pgto.explica'
              :cpntConfig='campos.vcto_pgto.config'
              :cpntPosicionar='campos.vcto_pgto.posicionar'
              :cpntTabIndex='campos.vcto_pgto.tabIndex'
              :cpntOnChange='(value) => { finRegRecDesOnChangeValueReferencia(value, "vcto_pgto") }'
              ></App-Calendario>
            </div>
          </template>
        </template>

        <template v-slot:th_id_pgto="{ coluna }">
          <div class="titulo">
            <!-- SETA O TITULO -->
            <span v-html="coluna.nome"></span>

            <!-- SETA A EXPLICAÇÃO DO CAMPO -->
            <App-Explica :cpntTitle='"Caso deseje alterar o tipo de pagamento para todas as parcelas selecione neste seletor referência."'></App-Explica>
          </div>

          <div class="mascara">
            <App-Select :data-time="time" class="fin-reg-rec-des--id_pgto"
            :cpntStatus='campos.id_pgto.status'
            :cpntId='cpntHash + "id_pgto"'
            :cpntTabIndex='campos.id_pgto.tabIndex'
            :cpntNome='campos.id_pgto.nome'
            :cpntValue='referencia.id_pgto'
            :cpntMensagem='campos.id_pgto.mensagem'
            :cpntMensagemTipo='campos.id_pgto.mensagemTipo'
            :cpntDisabled='campos.id_pgto.disabled'
            :cpntMostrar='campos.id_pgto.mostrar'
            :cpntExplica='campos.id_pgto.explica'
            :cpntPlaceholder='campos.id_pgto.placeholder'
            :cpntValueRef='campos.id_pgto.valueRef'
            :cpntRouter='campos.id_pgto.router'
            :cpntMethod='campos.id_pgto.method'
            :cpntField='campos.id_pgto.field'
            :cpntWhere='campos.id_pgto.where'
            :cpntAddButForm='campos.id_pgto.addButForm'
            :cpntKeyMostra='campos.id_pgto.keyMostra'
            :cpntTipoOrder='campos.id_pgto.tipoOrder'
            :cpntOrder='campos.id_pgto.order'
            :cpntOptions='campos.id_pgto.options'
            :cpntKeyValue='campos.id_pgto.keyValue'
            :cpntSearchMinimo='campos.id_pgto.searchMinimo'
            :cpntMask='campos.id_pgto.mask'
            :cpntNewOption='campos.id_pgto.newOption'
            :cpntOptionInicialNome='campos.id_pgto.optionInicialNome'
            :cpntOptionInicialValue='campos.id_pgto.optionInicialValue'
            :cpntOnChange='(value) => { finRegRecDesOnChangeValueReferencia(value, "id_pgto") }'
            :cpntOnBuscarOptions='(callback) => { campos.id_pgto.onBuscarOptions(callback, "referencia") }'
            ></App-Select>
          </div>
        </template>

        <template v-slot:th_id_conta="{ coluna }">
          <div class="titulo">
            <!-- SETA O TITULO -->
            <span v-html="coluna.nome"></span>

            <!-- SETA A EXPLICAÇÃO DO CAMPO -->
            <App-Explica :cpntTitle='"Caso deseje alterar a conta para todas as parcelas selecione neste seletor referência."'></App-Explica>
          </div>

          <div class="mascara">
            <App-Select :data-time="time" class="fin-reg-rec-des--id_conta"
            :cpntStatus='campos.id_conta.status'
            :cpntId='cpntHash + "id_conta"'
            :cpntTabIndex='campos.id_conta.tabIndex'
            :cpntNome='campos.id_conta.nome'
            :cpntValue='referencia.id_conta'
            :cpntMensagem='campos.id_conta.mensagem'
            :cpntMensagemTipo='campos.id_conta.mensagemTipo'
            :cpntDisabled='campos.id_conta.disabled'
            :cpntMostrar='campos.id_conta.mostrar'
            :cpntExplica='campos.id_conta.explica'
            :cpntPlaceholder='campos.id_conta.placeholder'
            :cpntValueRef='campos.id_conta.valueRef'
            :cpntRouter='campos.id_conta.router'
            :cpntMethod='campos.id_conta.method'
            :cpntField='campos.id_conta.field'
            :cpntWhere='campos.id_conta.where'
            :cpntAddButForm='campos.id_conta.addButForm'
            :cpntKeyMostra='campos.id_conta.keyMostra'
            :cpntTipoOrder='campos.id_conta.tipoOrder'
            :cpntOrder='campos.id_conta.order'
            :cpntOptions='campos.id_conta.options'
            :cpntKeyValue='campos.id_conta.keyValue'
            :cpntSearchMinimo='campos.id_conta.searchMinimo'
            :cpntMask='campos.id_conta.mask'
            :cpntNewOption='() => { campos.id_conta.newOption("referencia") }'
            :cpntOptionInicialNome='campos.id_conta.optionInicialNome'
            :cpntOptionInicialValue='campos.id_conta.optionInicialValue'
            :cpntOnChange='(value) => { finRegRecDesOnChangeValueReferencia(value, "id_conta") }'
            :cpntOnBuscarOptions='(callback) => { campos.id_conta.onBuscarOptions(callback) }'
            ></App-Select>
          </div>
        </template>

        <template v-slot:th_obs="{ coluna }">
          <div class="titulo">
            <!-- SETA O TITULO -->
            <span v-html="coluna.nome"></span>

            <!-- SETA A EXPLICAÇÃO DO CAMPO -->
            <App-Explica :cpntTitle='"Digite o texto neste campo referência caso deseje que todas as parcelas tenham a mesma observação."'></App-Explica>
          </div>

          <div class="mascara">
            <App-Input :data-time="time" class="fin-reg-rec-des--obs"
            :cpntStatus='campos.obs.status'
            :cpntId='cpntHash + "obs"'
            :class='campos.obs.class'
            :cpntTabIndex='campos.obs.tabIndex'
            :cpntClassDivField='campos.obs.classDivField'
            :cpntNome='campos.obs.nome'
            :cpntValue='referencia.obs'
            :cpntAutoComplete='campos.obs.autocomplete'
            :cpntMask='campos.obs.mask'
            :cpntOptionInicialNome='campos.obs.optionInicialNome'
            :cpntOptionInicialValue='campos.obs.optionInicialValue'
            :cpntDisabled='campos.obs.disabled'
            :cpntMostrar='campos.obs.mostrar'
            :cpntAutoFocus='campos.obs.autofocus'
            :cpntMensagem='campos.obs.mensagem'
            :cpntMensagemTipo='campos.obs.mensagemTipo'
            :cpntPlaceholder='campos.obs.placeholder'
            :cpntPosicionar='campos.obs.posicionar'
            :cpntOnChange='(value) => { finRegRecDesOnChangeValueReferencia(value, "obs") }'
            ></App-Input>
          </div>
        </template>

        <template v-slot:th_id_carteira="{ coluna }">
          <div class="titulo">
            <!-- SETA O TITULO -->
            <span v-html="coluna.nome"></span>

            <!-- SETA A EXPLICAÇÃO DO CAMPO -->
            <App-Explica :cpntTitle='"Caso deseje alterar o " + coluna.nome + " para todas as parcelas selecione neste seletor referência."'></App-Explica>
          </div>

          <div class="mascara">
            <App-Select :data-time="time" class="fin-reg-rec-des--id_carteira"
            :cpntStatus='campos.id_carteira.status'
            :cpntId='cpntHash + "id_carteira"'
            :cpntTabIndex='campos.id_carteira.tabIndex'
            :cpntNome='campos.id_carteira.nome'
            :cpntValue='referencia.id_carteira'
            :cpntMensagem='campos.id_carteira.mensagem'
            :cpntMensagemTipo='campos.id_carteira.mensagemTipo'
            :cpntDisabled='campos.id_carteira.disabled'
            :cpntMostrar='campos.id_carteira.mostrar'
            :cpntExplica='campos.id_carteira.explica'
            :cpntPlaceholder='campos.id_carteira.placeholder'
            :cpntValueRef='campos.id_carteira.valueRef'
            :cpntRouter='campos.id_carteira.router'
            :cpntMethod='campos.id_carteira.method'
            :cpntField='campos.id_carteira.field'
            :cpntWhere='campos.id_carteira.where'
            :cpntAddButForm='campos.id_carteira.addButForm'
            :cpntKeyMostra='campos.id_carteira.keyMostra'
            :cpntTipoOrder='campos.id_carteira.tipoOrder'
            :cpntOrder='campos.id_carteira.order'
            :cpntOptions='campos.id_carteira.options'
            :cpntKeyValue='campos.id_carteira.keyValue'
            :cpntSearchMinimo='campos.id_carteira.searchMinimo'
            :cpntMask='campos.id_carteira.mask'
            :cpntNewOption='campos.id_carteira.newOption'
            :cpntOptionInicialNome='campos.id_carteira.optionInicialNome'
            :cpntOptionInicialValue='campos.id_carteira.optionInicialValue'
            :cpntOnChange='(value) => { finRegRecDesOnChangeValueReferencia(value, "id_carteira") }'
            :cpntOnBuscarOptions='(callback) => { campos.id_carteira.onBuscarOptions(callback) }'
            ></App-Select>
          </div>
        </template>

        <template v-slot:th_status="{ coluna }">
          <div class="titulo">
            <!-- SETA O TITULO -->
            <span v-html="coluna.nome"></span>

            <!-- SETA A EXPLICAÇÃO DO CAMPO -->
            <App-Explica :cpntTitle='"Caso deseje alterar o status para todas as parcelas selecione neste seletor referência."'></App-Explica>
          </div>

          <div class="mascara">
            <App-Select :data-time="time" class="fin-reg-rec-des--status"
            :cpntStatus='campos.status.status'
            :cpntId='cpntHash + "status"'
            :cpntTabIndex='campos.status.tabIndex'
            :cpntNome='campos.status.nome'
            :cpntValue='referencia.status'
            :cpntMensagem='campos.status.mensagem'
            :cpntMensagemTipo='campos.status.mensagemTipo'
            :cpntDisabled='campos.status.disabled'
            :cpntMostrar='campos.status.mostrar'
            :cpntExplica='campos.status.explica'
            :cpntPlaceholder='campos.status.placeholder'
            :cpntValueRef='campos.status.valueRef'
            :cpntRouter='campos.status.router'
            :cpntMethod='campos.status.method'
            :cpntField='campos.status.field'
            :cpntWhere='campos.status.where'
            :cpntAddButForm='campos.status.addButForm'
            :cpntKeyMostra='campos.status.keyMostra'
            :cpntTipoOrder='campos.status.tipoOrder'
            :cpntOrder='campos.status.order'
            :cpntOptions='campos.status.options'
            :cpntKeyValue='campos.status.keyValue'
            :cpntSearchMinimo='campos.status.searchMinimo'
            :cpntMask='campos.status.mask'
            :cpntNewOption='campos.status.newOption'
            :cpntOptionInicialNome='campos.status.optionInicialNome'
            :cpntOptionInicialValue='campos.status.optionInicialValue'
            :cpntOnChange='(value) => { finRegRecDesOnChangeValueReferencia(value, "status") }'
            :cpntOnBuscarOptions='(callback) => { campos.status.onBuscarOptions(callback, "referencia") }'
            ></App-Select>
          </div>
        </template>

        <template v-slot:col_valor="{ linha, indexL }">
          <App-Input :data-time="time" class="fin-reg-rec-des--valor"
          :cpntStatus='campos.valor.status'
          :cpntId='cpntHash + "valor--" + indexL'
          :class='campos.valor.class'
          :cpntTabIndex='campos.valor.tabIndex'
          :cpntClassDivField='campos.valor.classDivField'
          :cpntNome='campos.valor.nome'
          :cpntValue='linha.valor'
          :cpntAutoComplete='campos.valor.autocomplete'
          :cpntMask='campos.valor.mask'
          :cpntOptionInicialNome='campos.valor.optionInicialNome'
          :cpntOptionInicialValue='campos.valor.optionInicialValue'
          :cpntDisabled='campos.valor.disabled'
          :cpntMostrar='campos.valor.mostrar'
          :cpntAutoFocus='campos.valor.autofocus'
          :cpntMensagem='linha.valor_mensagem'
          :cpntMensagemTipo='campos.valor.mensagemTipo'
          :cpntPlaceholder='campos.valor.placeholder'
          :cpntPosicionar='campos.valor.posicionar'
          :cpntOnChange='(value) => { finRegRecDesOnChangeValue(value, indexL, "valor") }'
          :cpntOnKeyPressEnter='() => { finRegRecDesOnKeyPressEnter(indexL, "valor") }'
          :ref="indexL + '--valor'"
          ></App-Input>
        </template>

        <template v-slot:col_vencimento="{ linha, indexL }">
          <template v-if="cpntTipo !== 'pgto_docfiscal' || [ '03', '3' ].indexOf(linha.id_pgto.id) !== -1">
            <App-Input :data-time="time" class="fin-reg-rec-des--vcto_soma" :style="finRegRecDesPegarValorReferencia('vcto_tipo') === 'S' ? '' : 'visibility: hidden;'" v-if="cpntTipo !== 'pgto_docfiscal' || finRegRecDesValorParcelas() > 1"
            :cpntStatus='campos.vcto_soma.status'
            :cpntId='cpntHash + "vcto_soma--" + indexL'
            :class='campos.vcto_soma.class'
            :cpntTabIndex='campos.vcto_soma.tabIndex'
            :cpntClassDivField='campos.vcto_soma.classDivField'
            :cpntNome='campos.vcto_soma.nome'
            :cpntValue='linha.vcto_soma'
            :cpntAutoComplete='campos.vcto_soma.autocomplete'
            :cpntMask='campos.vcto_soma.mask'
            :cpntOptionInicialNome='campos.vcto_soma.optionInicialNome'
            :cpntOptionInicialValue='campos.vcto_soma.optionInicialValue'
            :cpntDisabled='campos.vcto_soma.disabled'
            :cpntMostrar='campos.vcto_soma.mostrar'
            :cpntAutoFocus='campos.vcto_soma.autofocus'
            :cpntMensagem='linha.vcto_soma_mensagem'
            :cpntMensagemTipo='campos.vcto_soma.mensagemTipo'
            :cpntPlaceholder='campos.vcto_soma.placeholder'
            :cpntPosicionar='campos.vcto_soma.posicionar'
            :cpntOnChange='(value) => { finRegRecDesOnChangeValue(value, indexL, "vcto_soma") }'
            :ref="indexL + '--vcto_soma'"
            ></App-Input>
  
            <App-Calendario :data-time="time" class="fin-reg-rec-des--vcto_pgto"
            :cpntStatus='campos.vcto_pgto.status'
            :cpntId='cpntHash + "vcto_pgto--" + indexL'
            :cpntClassDivField='campos.vcto_pgto.classDivField'
            :cpntNome='campos.vcto_pgto.nome'
            :cpntValue='linha.vcto_pgto'
            :cpntAutoComplete='campos.vcto_pgto.autocomplete'
            :cpntMask='campos.vcto_pgto.mask'
            :cpntDisabled='campos.vcto_pgto.disabled'
            :cpntMostrar='campos.vcto_pgto.mostrar'
            :cpntAutoFocus='campos.vcto_pgto.autofocus'
            :cpntMensagem='linha.vcto_pgto_mensagem'
            :cpntMensagemTipo='campos.vcto_pgto.mensagemTipo'
            :cpntPlaceholder='campos.vcto_pgto.placeholder'
            :cpntExplica='campos.vcto_pgto.explica'
            :cpntConfig='campos.vcto_pgto.config'
            :cpntPosicionar='campos.vcto_pgto.posicionar'
            :cpntTabIndex='campos.vcto_pgto.tabIndex'
            :cpntOnChange='(value) => { finRegRecDesOnChangeValue(value, indexL, "vcto_pgto") }'
            :cpntOnKeyPressEnter='() => { finRegRecDesOnKeyPressEnter(indexL, "vcto_pgto") }'
            :cpntOnKeyDown='(cpntId, event) => { finRegRecDesOnKeyDown(event, indexL, "vcto_pgto") }'
            :ref="indexL + '--vcto_pgto'"
            ></App-Calendario>
          </template>
        </template>

        <template v-slot:col_id_pgto="{ linha, indexL }">
          <App-Select :data-time="time" class="fin-reg-rec-des--id_pgto"
          :cpntStatus='campos.id_pgto.status'
          :cpntId='cpntHash + "id_pgto--" + indexL'
          :cpntTabIndex='campos.id_pgto.tabIndex'
          :cpntNome='campos.id_pgto.nome'
          :cpntValue='linha.id_pgto'
          :cpntMensagem='linha.id_pgto_mensagem'
          :cpntMensagemTipo='campos.id_pgto.mensagemTipo'
          :cpntDisabled='campos.id_pgto.disabled'
          :cpntMostrar='campos.id_pgto.mostrar'
          :cpntExplica='campos.id_pgto.explica'
          :cpntPlaceholder='campos.id_pgto.placeholder'
          :cpntValueRef='campos.id_pgto.valueRef'
          :cpntRouter='campos.id_pgto.router'
          :cpntMethod='campos.id_pgto.method'
          :cpntField='campos.id_pgto.field'
          :cpntWhere='campos.id_pgto.where'
          :cpntAddButForm='campos.id_pgto.addButForm'
          :cpntKeyMostra='campos.id_pgto.keyMostra'
          :cpntTipoOrder='campos.id_pgto.tipoOrder'
          :cpntOrder='campos.id_pgto.order'
          :cpntOptions='campos.id_pgto.options'
          :cpntKeyValue='campos.id_pgto.keyValue'
          :cpntSearchMinimo='campos.id_pgto.searchMinimo'
          :cpntMask='campos.id_pgto.mask'
          :cpntNewOption='campos.id_pgto.newOption'
          :cpntOptionInicialNome='campos.id_pgto.optionInicialNome'
          :cpntOptionInicialValue='campos.id_pgto.optionInicialValue'
          :cpntOnChange='(value) => { finRegRecDesOnChangeValue(value, indexL, "id_pgto") }'
          :cpntOnKeyPressEnter='() => { finRegRecDesOnKeyPressEnter(indexL, "id_pgto") }'
          :cpntOnBuscarOptions='(callback) => { campos.id_pgto.onBuscarOptions(callback, indexL) }'
          :ref="indexL + '--id_pgto'"
          ></App-Select>
        </template>

        <template v-slot:col_id_conta="{ linha, indexL }">
          <App-Select :data-time="time" class="fin-reg-rec-des--id_conta"
          :cpntStatus='campos.id_conta.status'
          :cpntId='cpntHash + "id_conta--" + indexL'
          :cpntTabIndex='campos.id_conta.tabIndex'
          :cpntNome='campos.id_conta.nome'
          :cpntValue='linha.id_conta'
          :cpntMensagem='linha.id_conta_mensagem'
          :cpntMensagemTipo='campos.id_conta.mensagemTipo'
          :cpntDisabled='campos.id_conta.disabled'
          :cpntMostrar='campos.id_conta.mostrar'
          :cpntExplica='campos.id_conta.explica'
          :cpntPlaceholder='campos.id_conta.placeholder'
          :cpntValueRef='campos.id_conta.valueRef'
          :cpntRouter='campos.id_conta.router'
          :cpntMethod='campos.id_conta.method'
          :cpntField='campos.id_conta.field'
          :cpntWhere='campos.id_conta.where'
          :cpntAddButForm='campos.id_conta.addButForm'
          :cpntKeyMostra='campos.id_conta.keyMostra'
          :cpntTipoOrder='campos.id_conta.tipoOrder'
          :cpntOrder='campos.id_conta.order'
          :cpntOptions='campos.id_conta.options'
          :cpntKeyValue='campos.id_conta.keyValue'
          :cpntSearchMinimo='campos.id_conta.searchMinimo'
          :cpntMask='campos.id_conta.mask'
          :cpntNewOption='() => { campos.id_conta.newOption(indexL) }'
          :cpntOptionInicialNome='campos.id_conta.optionInicialNome'
          :cpntOptionInicialValue='campos.id_conta.optionInicialValue'
          :cpntOnChange='(value) => { finRegRecDesOnChangeValue(value, indexL, "id_conta") }'
          :cpntOnBuscarOptions='(callback) => { campos.id_conta.onBuscarOptions(callback) }'
          :ref="indexL + '--id_conta'"
          ></App-Select>
        </template>

        <template v-slot:col_obs="{ linha, indexL }">
          <App-Input :data-time="time" class="fin-reg-rec-des--obs"
          :cpntStatus='campos.obs.status'
          :cpntId='cpntHash + "obs--" + indexL'
          :class='campos.obs.class'
          :cpntTabIndex='campos.obs.tabIndex'
          :cpntClassDivField='campos.obs.classDivField'
          :cpntNome='campos.obs.nome'
          :cpntValue='linha.obs'
          :cpntAutoComplete='campos.obs.autocomplete'
          :cpntMask='campos.obs.mask'
          :cpntOptionInicialNome='campos.obs.optionInicialNome'
          :cpntOptionInicialValue='campos.obs.optionInicialValue'
          :cpntDisabled='campos.obs.disabled'
          :cpntMostrar='campos.obs.mostrar'
          :cpntAutoFocus='campos.obs.autofocus'
          :cpntMensagem='linha.obs_mensagem'
          :cpntMensagemTipo='campos.obs.mensagemTipo'
          :cpntPlaceholder='campos.obs.placeholder'
          :cpntPosicionar='campos.obs.posicionar'
          :cpntOnChange='(value) => { finRegRecDesOnChangeValue(value, indexL, "obs") }'
          :ref="indexL + '--obs'"
          ></App-Input>
        </template>

        <template v-slot:col_id_carteira="{ linha, indexL }">
          <App-Select :data-time="time" class="fin-reg-rec-des--id_carteira"
          :cpntStatus='campos.id_carteira.status'
          :cpntId='cpntHash + "id_carteira--" + indexL'
          :cpntTabIndex='campos.id_carteira.tabIndex'
          :cpntNome='campos.id_carteira.nome'
          :cpntValue='linha.id_carteira'
          :cpntMensagem='linha.id_carteira_mensagem'
          :cpntMensagemTipo='campos.id_carteira.mensagemTipo'
          :cpntDisabled='campos.id_carteira.disabled'
          :cpntMostrar='campos.id_carteira.mostrar'
          :cpntExplica='campos.id_carteira.explica'
          :cpntPlaceholder='campos.id_carteira.placeholder'
          :cpntValueRef='campos.id_carteira.valueRef'
          :cpntRouter='campos.id_carteira.router'
          :cpntMethod='campos.id_carteira.method'
          :cpntField='campos.id_carteira.field'
          :cpntWhere='campos.id_carteira.where'
          :cpntAddButForm='campos.id_carteira.addButForm'
          :cpntKeyMostra='campos.id_carteira.keyMostra'
          :cpntTipoOrder='campos.id_carteira.tipoOrder'
          :cpntOrder='campos.id_carteira.order'
          :cpntOptions='campos.id_carteira.options'
          :cpntKeyValue='campos.id_carteira.keyValue'
          :cpntSearchMinimo='campos.id_carteira.searchMinimo'
          :cpntMask='campos.id_carteira.mask'
          :cpntNewOption='campos.id_carteira.newOption'
          :cpntOptionInicialNome='campos.id_carteira.optionInicialNome'
          :cpntOptionInicialValue='campos.id_carteira.optionInicialValue'
          :cpntOnChange='(value) => { finRegRecDesOnChangeValue(value, indexL, "id_carteira") }'
          :cpntOnBuscarOptions='(callback) => { campos.id_carteira.onBuscarOptions(callback) }'
          :ref="indexL + '--id_carteira'"
          ></App-Select>
        </template>

        <template v-slot:col_status="{ linha, indexL }">
          <App-Select :data-time="time" class="fin-reg-rec-des--status"
          :cpntStatus='campos.status.status'
          :cpntId='cpntHash + "status--" + indexL'
          :cpntTabIndex='campos.status.tabIndex'
          :cpntNome='campos.status.nome'
          :cpntValue='linha.status'
          :cpntMensagem='linha.status_mensagem'
          :cpntMensagemTipo='campos.status.mensagemTipo'
          :cpntDisabled='campos.status.disabled'
          :cpntMostrar='campos.status.mostrar'
          :cpntExplica='campos.status.explica'
          :cpntPlaceholder='campos.status.placeholder'
          :cpntValueRef='campos.status.valueRef'
          :cpntRouter='campos.status.router'
          :cpntMethod='campos.status.method'
          :cpntField='campos.status.field'
          :cpntWhere='campos.status.where'
          :cpntAddButForm='campos.status.addButForm'
          :cpntKeyMostra='campos.status.keyMostra'
          :cpntTipoOrder='campos.status.tipoOrder'
          :cpntOrder='campos.status.order'
          :cpntOptions='campos.status.options'
          :cpntKeyValue='campos.status.keyValue'
          :cpntSearchMinimo='campos.status.searchMinimo'
          :cpntMask='campos.status.mask'
          :cpntNewOption='campos.status.newOption'
          :cpntOptionInicialNome='campos.status.optionInicialNome'
          :cpntOptionInicialValue='campos.status.optionInicialValue'
          :cpntOnChange='(value) => { finRegRecDesOnChangeValue(value, indexL, "status") }'
          :cpntOnBuscarOptions='(callback) => { campos.status.onBuscarOptions(callback, indexL) }'
          :ref="indexL + '--status'"
          ></App-Select>
        </template>
      </App-Tabela>

      <!-- SETA O VALOR TOTAL DAS PARCELAS -->
      <div class="total">
        Total R$ <span v-html="valorTotal"></span>
      </div>

      <!-- SETA OS BOTÃO PARA INSERIR NO FINANCEIRO -->
      <div class="botoes">
        <App-Button :cpntStatus="extra === 'carregando' ? extra : ''" :cpntClass="[ 'btn', 'btn-primary' ]" @onClick="finRegRecDesSalvarDados">
          <span v-html="([ '', null, undefined, '1', 1 ].indexOf(finRegRecDesValorParcelas()) !== -1 ? 'Inserir Valor' : 'Inserir Valores')"></span>
        </App-Button>
      </div>
    </template>

    <!-- SETA O FOMRULARIO DE ADICIONAR NOVA CONTA -->
    <App-Financeiro-Config-Contas-Bancarias v-if="extra !== null && extra.tipo === 'id_conta'"
    :cpntId='extra.id'
    :cpntFecharFormulario='extra.callback'
    ></App-Financeiro-Config-Contas-Bancarias>
  </div>
</template>

<style scoped>
.fin-reg-rec-des {
  margin-top: 10px;
}
  .fin-reg-rec-des > .parcelas {
    width: 300px;
    margin: 0px auto;
    text-align: center;
  }
    .fin-reg-rec-des > .parcelas > .seletor {
      margin-top: 10px;
    }
      .fin-reg-rec-des > .parcelas > .seletor > div {
        display: inline-block;
        vertical-align: middle;
      }
      .fin-reg-rec-des > .parcelas > .seletor > .fin-reg-rec-des--parcelas {
        width: 100px;
        margin-left: 10px;
      }

  .fin-reg-rec-des > .tabela {
    margin-top: 10px;
  }

  .fin-reg-rec-des > .total {
    margin-top: 5px;
    padding-left: 65px;
    font-size: calc(100% - 2px);
  }
    .fin-reg-rec-des > .total > span {
      font-weight: bold;
      color: red;
    }

  .fin-reg-rec-des > .botoes {
    text-align: center;
  }
    .fin-reg-rec-des > .botoes > button {
      width: 130px;
    }
  .fin-reg-rec-des > .tabela.resumido ~ .botoes {
    margin-top: 15px;
  }
</style>

<style>
.fin-reg-rec-des > .tabela.resumido > thead > tr > th {
  font-size: 13px !important;
}
.fin-reg-rec-des > .tabela.fin-reg--compra > thead > tr > th {
  background: -webkit-gradient( linear, left top, left bottom, color-stop(0.05, #f4f1c3), color-stop(1, #ece9bd) );
  background: -moz-linear-gradient( center top, #f4f1c3 5%, #ece9bd 100% );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f4f1c3', endColorstr='#ece9bd');
  background-color: #f4f1c3;
  border: 1px solid #cbcc70;
}
.fin-reg-rec-des > .tabela.fin-reg--compra > thead > tr > th {
  border: 1px solid #cbcc70 !important;
}
.fin-reg-rec-des > .tabela.fin-reg--venda > thead > tr > th {
  background: -webkit-gradient( linear, left top, left bottom, color-stop(0.05, #cdfacd), color-stop(1, #bdecbd) );
  background: -moz-linear-gradient( center top, #cdfacd 5%, #bdecbd 100% );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#cdfacd', endColorstr='#bdecbd');
  background-color: #cdfacd;
  border: 1px solid #70cc70;
}
.fin-reg-rec-des > .tabela.fin-reg--venda > thead > tr > th {
  border: 1px solid #70cc70 !important;
}

.fin-reg-rec-des > .parcelas > .seletor > .fin-reg-rec-des--parcelas > .select2-container > a {
  text-align: center;
}

.fin-reg-rec-des > .tabela.resumido ~ .total,
.fin-reg-rec-des > .tabela.resumido > thead > tr > th:not(.col_vencimento) > div.mascara,
.fin-reg-rec-des > .tabela.resumido > thead > tr > th > div.titulo > .cpnt-app-explica {
  display: none;
}

.fin-reg-rec-des > .tabela > tbody > tr > td {
  padding: 6px 4px !important;
}
  .fin-reg-rec-des > .tabela > tbody > tr > td.col_parcela {
    width: 60px !important;
    min-width: 30px !important;
    max-width: 60px !important;
    font-size: calc(100% + 1px);
  }
  .fin-reg-rec-des > .tabela > thead > tr > th.col_valor > div > .fin-reg-rec-des--valor_tipo,
  .fin-reg-rec-des > .tabela > thead > tr > th.col_valor > div > .fin-reg-rec-des--valor {
    display: inline-block;
  }
  .fin-reg-rec-des > .tabela > thead > tr > th.col_valor > div > .fin-reg-rec-des--valor_tipo {
    width: 45px !important;
    min-width: 45px !important;
    max-width: 45px !important;
  }
  .fin-reg-rec-des > .tabela > thead > tr > th.col_valor > div > .fin-reg-rec-des--valor {
    margin-left: 3px;
    width: calc(100% - 45px - 3px) !important;
    min-width: calc(100% - 45px - 3px) !important;
    max-width: calc(100% - 45px - 3px) !important;
  }
    .fin-reg-rec-des > .tabela > thead > tr > th.col_valor > div > .fin-reg-rec-des--valor_tipo > .select2-container > a,
    .fin-reg-rec-des > .tabela > thead > tr > th.col_valor > div > .fin-reg-rec-des--valor > input {
      color: #333 !important;
      font-size: calc(100% + 1px) !important;
      font-weight: normal;
      text-align: center !important;
      background-color: #fff4b6 !important;
      border: 1px solid #d0c9c9 !important;
    }
  .fin-reg-rec-des > .tabela > thead > tr > th.col_valor,
  .fin-reg-rec-des > .tabela > tbody > tr > td.col_valor {
    width: 150px !important;
    min-width: 120px !important;
    max-width: 150px !important;
  }
    .fin-reg-rec-des > .tabela > tbody > tr > td.col_valor > div > span > div > input {
      text-align: right;
      font-size: calc(100% + 1px);
    }

  .fin-reg-rec-des > .tabela > thead > tr > th.col_vencimento > div > .fin-reg-rec-des--vcto_tipo,
  .fin-reg-rec-des > .tabela > thead > tr > th.col_vencimento > div > .fin-reg-rec-des--vcto_soma,
  .fin-reg-rec-des > .tabela > thead > tr > th.col_vencimento > div > .fin-reg-rec-des--vcto_pgto {
    display: inline-block;
  }
  .fin-reg-rec-des > .tabela > thead > tr > th.col_vencimento > div > .fin-reg-rec-des--vcto_tipo {
    margin-right: 3px;
    width: 45px !important;
    min-width: 45px !important;
    max-width: 45px !important;
  }
  .fin-reg-rec-des > .tabela > thead > tr > th.col_vencimento > div > .fin-reg-rec-des--vcto_soma {
    margin-right: 3px;
    width: 35px !important;
    min-width: 35px !important;
    max-width: 35px !important;
  }
  .fin-reg-rec-des > .tabela > thead > tr > th.col_vencimento > div > .fin-reg-rec-des--vcto_pgto {
    width: calc(100% - 80px - 6px) !important;
    min-width: calc(100% - 80px - 6px) !important;
    max-width: calc(100% - 80px - 6px) !important;
  }
    .fin-reg-rec-des > .tabela > thead > tr > th.col_vencimento > div > .fin-reg-rec-des--vcto_tipo > .select2-container > a,
    .fin-reg-rec-des > .tabela > thead > tr > th.col_vencimento > div > .fin-reg-rec-des--vcto_soma > input,
    .fin-reg-rec-des > .tabela > thead > tr > th.col_vencimento > div > .fin-reg-rec-des--vcto_pgto > input {
      color: #333 !important;
      font-size: calc(100% + 1px) !important;
      font-weight: normal;
      text-align: center !important;
      background-color: #fff4b6 !important;
      border: 1px solid #d0c9c9 !important;
    }
  .fin-reg-rec-des > .tabela > thead > tr > th.col_vencimento,
  .fin-reg-rec-des > .tabela > tbody > tr > td.col_vencimento {
    width: 180px !important;
    min-width: 180px !important;
    max-width: 180px !important;
  }
    .fin-reg-rec-des > .tabela > tbody > tr > td.col_vencimento > div > span > .fin-reg-rec-des--vcto_soma,
    .fin-reg-rec-des > .tabela > tbody > tr > td.col_vencimento > div > span > .fin-reg-rec-des--vcto_pgto {
      display: inline-block;
    }
    .fin-reg-rec-des > .tabela > tbody > tr > td.col_vencimento > div > span > .fin-reg-rec-des--vcto_soma {
      width: 35px !important;
      min-width: 35px !important;
      max-width: 35px !important;
    }
    .fin-reg-rec-des > .tabela > tbody > tr > td.col_vencimento > div > span > .fin-reg-rec-des--vcto_pgto {
      margin-left: 3px;
      width: calc(100% - 35px - 3px) !important;
      min-width: calc(100% - 35px - 3px) !important;
      max-width: calc(100% - 35px - 3px) !important;
    }
      .fin-reg-rec-des > .tabela > tbody > tr > td.col_vencimento > div > span > .fin-reg-rec-des--vcto_soma > input {
        background-color: #fff4b6 !important;
        border: 1px solid #d0c9c9 !important;
      }
      .fin-reg-rec-des > .tabela > tbody > tr > td.col_vencimento > div > span > .fin-reg-rec-des--vcto_soma > input,
      .fin-reg-rec-des > .tabela > tbody > tr > td.col_vencimento > div > span > .fin-reg-rec-des--vcto_pgto > input {
        font-size: calc(100% + 1px);
        text-align: center;
      }

  /* .fin-reg-rec-des > .tabela > thead > tr > th.col_id_pgto,
  .fin-reg-rec-des > .tabela > tbody > tr > td.col_id_pgto {
    width: 120px !important;
    min-width: 120px !important;
    max-width: 120px !important;
  } */
    .fin-reg-rec-des > .tabela > thead > tr > th.col_id_pgto > div > .fin-reg-rec-des--id_pgto > .select2-container > a {
      color: #333 !important;
      font-size: calc(100% + 1px) !important;
      font-weight: normal;
      text-align: center !important;
      background-color: #fff4b6 !important;
      border: 1px solid #d0c9c9 !important;
    }
    .fin-reg-rec-des > .tabela > tbody > tr > td.col_id_pgto > div > span > .fin-reg-rec-des--id_pgto > .select2-container > a {
      text-align: center !important;
    }

  /* .fin-reg-rec-des > .tabela > thead > tr > th.col_id_conta,
  .fin-reg-rec-des > .tabela > tbody > tr > td.col_id_conta {
    width: 200px !important;
    min-width: 150px !important;
    max-width: 200px !important;
  } */
    .fin-reg-rec-des > .tabela > thead > tr > th.col_id_conta > div > .fin-reg-rec-des--id_conta > .select2-container > a {
      color: #333 !important;
      font-size: calc(100% + 1px) !important;
      font-weight: normal;
      text-align: center !important;
      background-color: #fff4b6 !important;
      border: 1px solid #d0c9c9 !important;
    }
    .fin-reg-rec-des > .tabela > tbody > tr > td.col_id_conta > div > span > .fin-reg-rec-des--id_conta > .select2-container > a {
      text-align: center !important;
    }

  .fin-reg-rec-des > .tabela > thead > tr > th.col_obs,
  .fin-reg-rec-des > .tabela > tbody > tr > td.col_obs {
    /* width: 180px !important; */
    /* min-width: 141px !important; */
    /* max-width: 180px !important; */
  }
    .fin-reg-rec-des > .tabela > thead > tr > th.col_obs > div > .fin-reg-rec-des--obs > input {
      color: #333 !important;
      font-size: calc(100% + 1px) !important;
      font-weight: normal;
      text-align: left !important;
      background-color: #fff4b6 !important;
      border: 1px solid #d0c9c9 !important;
    }

  /* .fin-reg-rec-des > .tabela > thead > tr > th.col_id_carteira,
  .fin-reg-rec-des > .tabela > tbody > tr > td.col_id_carteira {
    width: 180px !important;
    min-width: 140px !important;
    max-width: 180px !important;
  } */
    .fin-reg-rec-des > .tabela > thead > tr > th.col_id_carteira > div > .fin-reg-rec-des--id_carteira > .select2-container > a {
      color: #333 !important;
      font-size: calc(100% + 1px) !important;
      font-weight: normal;
      text-align: center !important;
      background-color: #fff4b6 !important;
      border: 1px solid #d0c9c9 !important;
    }
    .fin-reg-rec-des > .tabela > tbody > tr > td.col_id_carteira > div > span > .fin-reg-rec-des--id_carteira > .select2-container > a {
      text-align: center !important;
    }

  /* .fin-reg-rec-des > .tabela > thead > tr > th.col_status,
  .fin-reg-rec-des > .tabela > tbody > tr > td.col_status {
    width: 110px !important;
    min-width: 80px !important;
    max-width: 110px !important;
  } */
    .fin-reg-rec-des > .tabela > thead > tr > th.col_status > div > .fin-reg-rec-des--status > .select2-container > a {
      color: #333 !important;
      font-size: calc(100% + 1px) !important;
      font-weight: normal;
      text-align: center !important;
      background-color: #fff4b6 !important;
      border: 1px solid #d0c9c9 !important;
    }
    .fin-reg-rec-des > .tabela > tbody > tr > td.col_status > div > span > .fin-reg-rec-des--status > .select2-container > a {
      text-align: center !important;
    }

  /* COLOCADO ESSAS LINHAS PARA NÃO ESTOURAR O CAMPO E FICAR SOBRE OUTRA COLUNA AO SELECIONAR UM VALOR NO SELECT2 */
  .fin-reg-rec-des > .tabela > tbody > tr > td > div {
    display: initial !important;
  }
    .fin-reg-rec-des > .tabela > tbody > tr > td > div > span {
      display: initial !important;
    }
</style>

<script>
  // IMPORTA BIBLIOTECA DEPENDENTE
  var moment = require('moment')

  export default {
    props: {
      cpntTipo: {
        required: true
      },
      cpntRefId: {
        required: true
      },
      cpntDemandaDados: {
        required: false,
        default: function () {
          return null
        }
      },

      cpntOnSalvarDados: {
        required: false,
        default: function () {
          return (formData, callback) => { callback(formData) }
        }
      },
      cpntOnAtualizaDados: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntHash: {
        required: false,
        type: String,
        default: function () {
          // INICIA A VARIAVEL ID
          var id = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          // PROCURAR A MONTAGEM DO CAMPO
          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            id = 'fin-reg-rec-des-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString() + '--'

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(id)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return id
        }
      }
    },
    components: {
      'App-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue'),
      'App-Financeiro-Config-Contas-Bancarias': () => import('@/components/financeiro/Config/Contas-Bancarias/Financeiro-Config-Contas-Bancarias.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        colunas: [],
        linhas: [],
        idPgtoIni: [ '2921', '9000' ].indexOf(this.$store.state.token.clu) !== -1 ? '37' : '1',
        extra: null,
        parcelas: {
          status: '',
          nome: '',
          keyValue: 'id',
          keyMostra: [ 'id' ],
          options: [ { id: '1' }, { id: '2' }, { id: '3' }, { id: '4' }, { id: '5' }, { id: '6' }, { id: '7' }, { id: '8' }, { id: '9' }, { id: '10' }, { id: '11' }, { id: '12' }, { id: '13' }, { id: '14' }, { id: '15' }, { id: '16' }, { id: '17' }, { id: '18' }, { id: '19' }, { id: '20' }, { id: '21' }, { id: '22' }, { id: '23' }, { id: '24' }, { id: '25' }, { id: '26' }, { id: '27' }, { id: '28' }, { id: '29' }, { id: '30' }, { id: '31' }, { id: '32' }, { id: '33' }, { id: '34' }, { id: '35' }, { id: '36' }, { id: '37' }, { id: '38' }, { id: '39' }, { id: '40' }, { id: '41' }, { id: '42' }, { id: '43' }, { id: '44' }, { id: '45' }, { id: '46' }, { id: '47' }, { id: '48' }, { id: '49' }, { id: '50' }, { id: '51' }, { id: '52' }, { id: '53' }, { id: '54' }, { id: '55' }, { id: '56' }, { id: '57' }, { id: '58' }, { id: '59' }, { id: '60' }, { id: '61' }, { id: '62' }, { id: '63' }, { id: '64' }, { id: '65' }, { id: '66' }, { id: '67' }, { id: '68' }, { id: '69' }, { id: '70' }, { id: '71' }, { id: '72' }, { id: '73' }, { id: '74' }, { id: '75' }, { id: '76' }, { id: '77' }, { id: '78' }, { id: '79' }, { id: '80' }, { id: '81' }, { id: '82' }, { id: '83' }, { id: '84' }, { id: '85' }, { id: '86' }, { id: '87' }, { id: '88' }, { id: '89' }, { id: '90' }, { id: '91' }, { id: '92' }, { id: '93' }, { id: '94' }, { id: '95' }, { id: '96' }, { id: '97' }, { id: '98' }, { id: '99' }, { id: '100' }, { id: '101' }, { id: '102' }, { id: '103' }, { id: '104' }, { id: '105' }, { id: '106' }, { id: '107' }, { id: '108' }, { id: '109' }, { id: '110' }, { id: '111' }, { id: '112' }, { id: '113' }, { id: '114' }, { id: '115' }, { id: '116' }, { id: '117' }, { id: '118' }, { id: '119' }, { id: '120' }, { id: '121' }, { id: '122' }, { id: '123' }, { id: '124' }, { id: '125' }, { id: '126' }, { id: '127' }, { id: '128' }, { id: '129' }, { id: '130' }, { id: '131' }, { id: '132' }, { id: '133' }, { id: '134' }, { id: '135' }, { id: '136' }, { id: '137' }, { id: '138' }, { id: '139' }, { id: '140' }, { id: '141' }, { id: '142' }, { id: '143' }, { id: '144' }, { id: '145' }, { id: '146' }, { id: '147' }, { id: '148' }, { id: '149' }, { id: '150' }, { id: '151' }, { id: '152' }, { id: '153' }, { id: '154' }, { id: '155' }, { id: '156' }, { id: '157' }, { id: '158' }, { id: '159' }, { id: '160' }, { id: '161' }, { id: '162' }, { id: '163' }, { id: '164' }, { id: '165' }, { id: '166' }, { id: '167' }, { id: '168' }, { id: '169' }, { id: '170' }, { id: '171' }, { id: '172' }, { id: '173' }, { id: '174' }, { id: '175' }, { id: '176' }, { id: '177' }, { id: '178' }, { id: '179' }, { id: '180' }, { id: '181' }, { id: '182' }, { id: '183' }, { id: '184' }, { id: '185' }, { id: '186' }, { id: '187' }, { id: '188' }, { id: '189' }, { id: '190' }, { id: '191' }, { id: '192' }, { id: '193' }, { id: '194' }, { id: '195' }, { id: '196' }, { id: '197' }, { id: '198' }, { id: '199' }, { id: '200' }, { id: '201' }, { id: '202' }, { id: '203' }, { id: '204' }, { id: '205' }, { id: '206' }, { id: '207' }, { id: '208' }, { id: '209' }, { id: '210' }, { id: '211' }, { id: '212' }, { id: '213' }, { id: '214' }, { id: '215' }, { id: '216' }, { id: '217' }, { id: '218' }, { id: '219' }, { id: '220' }, { id: '221' }, { id: '222' }, { id: '223' }, { id: '224' }, { id: '225' }, { id: '226' }, { id: '227' }, { id: '228' }, { id: '229' }, { id: '230' }, { id: '231' }, { id: '232' }, { id: '233' }, { id: '234' }, { id: '235' }, { id: '236' }, { id: '237' }, { id: '238' }, { id: '239' }, { id: '240' } ],
          mostrar: true,
          optionInicialNome: 'Selecione',
          value: { id: '1' },
          valueIni: '',
          disabled: false
        },
        demanda: null,
        valorTotal: '0,00',
        referencia: {
          valor: '0',
          valor_tipo: { id: 'D' },
          vcto_tipo: { id: 'S' },
          vcto_soma: '',
          vcto_pgto: '',
          id_pgto: '',
          id_conta: '',
          obs: '',
          id_carteira: '',
          status: ''
        },
        campos: {
          valor_tipo: {
            status: '',
            nome: '',
            keyValue: 'id',
            keyMostra: [ 'id' ],
            options: [ { id: 'D' }, { id: 'C' } ],
            mostrar: true,
            // optionInicialNome: 'Selecione',
            value: { id: 'D' },
            valueIni: '',
            disabled: false
          },
          valor: {
            status: '',
            class: '',
            nome: '',
            mask: 'valorMoeda'
          },
          vcto_tipo: {
            status: '',
            nome: '',
            keyValue: 'id',
            keyMostra: [ 'id' ],
            options: [ { id: 'S' }, { id: 'D' }, { id: 'C' } ],
            mostrar: true,
            // optionInicialNome: 'Selecione',
            value: { id: 'S' },
            valueIni: '',
            disabled: false
          },
          vcto_soma: {
            status: '',
            class: '',
            mostrar: true,
            nome: ''
          },
          vcto_pgto: {
            status: '',
            class: '',
            nome: '',
            mostrar: true,
            mask: 'data'
          },
          id_pgto: {
            status: '',
            nome: '',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            mostrar: true,
            // optionInicialNome: 'Selecione',
            value: '',
            valueIni: '',
            disabled: false,
            onBuscarOptions: this.finRegRecDesBuscarTipoPagamento
          },
          id_conta: {
            status: '',
            nome: '',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            mostrar: true,
            // optionInicialNome: 'Selecione',
            value: '',
            valueIni: '',
            disabled: false,
            newOption: this.finRegRecDesAdicionarNovaConta,
            onBuscarOptions: this.finRegRecDesBuscarContaBancaria
          },
          obs: {
            status: '',
            class: '',
            mostrar: true,
            nome: ''
          },
          id_carteira: {
            status: '',
            nome: '',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            mostrar: true,
            // optionInicialNome: 'Selecione',
            value: '',
            valueIni: '',
            newOption: true,
            disabled: false,
            onBuscarOptions: this.finRegRecDesBuscarCentroDeCusto
          },
          status: {
            status: '',
            nome: '',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            mostrar: true,
            // optionInicialNome: 'Selecione',
            value: '',
            valueIni: '',
            disabled: false,
            onBuscarOptions: this.finRegRecDesBuscarStatus
          }
        }
      }
    },
    mounted: function () {
      this.finRegRecDesIniciar()
    },
    methods: {
      finRegRecDesIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.finRegRecDesSetarStatusGeral('carregando')

        // LIMPA AS VARIAVEIS PARA INICIAR
        this.colunas = []
        this.linhas = []
        this.demanda = null

        // CARREGA AS COLUNAS DA TABELA
        this.finRegRecDesMontarColunas()

        // INICIA O CARREGAMENTO DOS VALORES
        this.finRegRecDesBuscarValorReferencia(() => {
          this.finRegRecDesSetarValorInicial(() => {
            this.finRegRecDesBuscarMascaraDfPagamento((montarLinhas = true) => {
              // SETA SE FOI MONTADO OS VALORES
              this.demanda.mascaramento = montarLinhas === false

              // VERIFICA O PROCESSO QUE DEVE FAZER
              if (montarLinhas === true) {
                // SETA O VALOR INICIAL NO CAMPO
                this.referencia.valor = this.demanda.virtual_total.geral.liquido
                this.referencia.vcto_pgto = this.demanda.vcto
  
                // MONTA AS LINHAS DA TALELA
                this.finRegRecDesMontarLinhas()

                // SETA O STATUS DA PAGINA
                this.finRegRecDesSetarStatusGeral('')
              } else {
                this.finRegRecDesSetarStatusGeral('')
              }

              // SETA O FOCUS NA TELA
              if (this.cpntTipo === 'pgto_docfiscal') {
                this.demEdiProTabItemSetaFocusCampo('0', 'valor')
              }
            })
          })
        })
      },
      demEdiProTabItemSetaFocusCampo: function (indexL, campo, tentativa = 0) {
        if (tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.demEdiProTabItemSetaFocusCampo(indexL, campo, (tentativa + 1)) }, 100) }

          // MONTA O NOME DA CHAVE QUE DEVE DAR FOCUS
          var chave = indexL + '--' + campo

          // VERIFICA SE O CAMPO EXISTE
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs[chave]) === -1) {
            // PEGA O ELEMENTO QUE DEVE DAR FOCUS
            var elemento = Array.isArray(this.$refs[chave]) === true ? this.$refs[chave][0] : this.$refs[chave]

            // VERIFICA SE O ELEMENTO EXISTE
            if ([ '', null, undefined ].indexOf(elemento) === -1 && [ '', null, undefined ].indexOf(elemento.cpntRealizarFocus) === -1 && typeof elemento.cpntRealizarFocus === 'function') {
              if (campo === 'id_pgto') {
                elemento.cpntRealizarFocus(false)
              } else {
                elemento.cpntRealizarFocus()
              }
            } else {
              reiniciar()
            }
          } else {
            reiniciar()
          }
        }
      },
      finRegRecDesSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      finRegRecDesOnChangeValueParcela: function (value, valor = true, vencimento = true) {
        // VERIFICA SE É O OPTION OU UM VALOR
        if (typeof value === 'string') {
          // PROCURA O OPTION SOLICITADO
          value = this.parcelas.options.filter(item => item.id === value)

          // VERIFICA SE O OPTION FOI ENCONTRADO
          value = value.length === 0 ? '' : value[0]
        }

        // SETA O VALOR NO CAMPO
        this.parcelas.value = value

        // LIMPA AS LINHAS EXISTENTES
        if (this.demanda.mascaramento === true && valor === true && vencimento === true) {
          // SETA O STATUS DA PAGINA
          this.finRegRecDesSetarStatusGeral('carregando')

          // MUDA O FLAG PARA FALSE
          this.demanda.mascaramento = false

          // SETA OS VALORES INICIAIS PARA TELA
          this.finRegRecDesSetarValorInicial(() => {
            // LIMPA AS LINHAS
            this.linhas = []

            // SETA O VALOR INICIAL NO CAMPO
            this.referencia.valor = this.demanda.virtual_total.geral.liquido
            this.referencia.vcto_tipo = { id: 'S' }
            this.referencia.vcto_soma = '7'
            this.referencia.vcto_pgto = this.demanda.vcto

            // MONTA AS LINHAS DA TALELA
            this.finRegRecDesMontarLinhas()

            // SETA O STATUS DA PAGINA
            this.finRegRecDesSetarStatusGeral('')
          })
        } else {  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA REMONTAR OS VALORES
          this.finRegRecDesMontarLinhas(valor, vencimento)
        }
      },
      finRegRecDesOnChangeValueReferencia: function (value, indexC) {
        // SETA O VALOR NO CAMPO
        this.$set(this.referencia, indexC, value)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // INICIA A VARIAVEL
        let indexL = 0

        // VERIFICA SE DEVE FAZER ALGUMA AÇÃO
        switch (indexC) {
          case 'valor':
          case 'valor_tipo':
            this.finRegRecDesMontarValorParcela()
            break

          case 'vcto_tipo':
            this.finRegRecDesMontarVencimento()
            break

          case 'vcto_soma':
            // SETA O VALOR EM TODAS AS LINHAS
            for (indexL = 0; indexL < this.linhas.length; indexL++) {
              // SETA O VALOR RECEBIDO
              this.$set(this.linhas[indexL], indexC, value)

              // LIMPA A CHAVE DE MESSAGEM DO CAMPO
              this.$set(this.linhas[indexL], (indexC + '_mensagem'), '')
            }

            // CHAMA A FUNÇÃO PARA ATUALIZAR OS VALORES
            this.finRegRecDesMontarVencimento()
            break

          case 'vcto_pgto':
            this.finRegRecDesMontarVencimento()
            break

          case 'id_pgto':
            // SETA O PAGAMENTO PARA TODAS AS LINHAS
            for (indexL = 0; indexL < this.linhas.length; indexL++) {
              // SETA O VALOR RECEBIDO
              this.$set(this.linhas[indexL], indexC, value)

              // LIMPA A CHAVE DE MESSAGEM DO CAMPO
              this.$set(this.linhas[indexL], (indexC + '_mensagem'), '')
            }

            // ALTERA A CONTA BANCARIA PARA TODAS AS LINHAS
            if (this.cpntTipo === 'compra' && [ '', null, undefined ].indexOf(value.id_con_pdr_despesa_.id) === -1) {
              this.finRegRecDesOnChangeValueReferencia(JSON.parse(JSON.stringify(value.id_con_pdr_despesa_)), 'id_conta')
            } else if (this.cpntTipo === 'venda' && [ '', null, undefined ].indexOf(value.id_con_pdr_receita_.id) === -1) {
              this.finRegRecDesOnChangeValueReferencia(JSON.parse(JSON.stringify(value.id_con_pdr_receita_)), 'id_conta')
            }
            break

          case 'id_conta':
            for (indexL = 0; indexL < this.linhas.length; indexL++) {
              // SETA O VALOR RECEBIDO
              this.$set(this.linhas[indexL], indexC, value)

              // LIMPA A CHAVE DE MESSAGEM DO CAMPO
              this.$set(this.linhas[indexL], (indexC + '_mensagem'), '')
            }
            break

          case 'obs':
            for (indexL = 0; indexL < this.linhas.length; indexL++) {
              // SETA O VALOR RECEBIDO
              this.$set(this.linhas[indexL], indexC, value)

              // LIMPA A CHAVE DE MESSAGEM DO CAMPO
              this.$set(this.linhas[indexL], (indexC + '_mensagem'), '')
            }
            break

          case 'id_carteira':
            if (value.id === '__NOVO_OPTION__') {
              this.finRegRecDesSalvaCarteira({ nome: value._text }, '0', (option) => { this.finRegRecDesOnChangeValueReferencia(option, indexC) })
            } else {
              for (indexL = 0; indexL < this.linhas.length; indexL++) {
                // SETA O VALOR RECEBIDO
                this.$set(this.linhas[indexL], indexC, value)
  
                // LIMPA A CHAVE DE MESSAGEM DO CAMPO
                this.$set(this.linhas[indexL], (indexC + '_mensagem'), '')
              }
            }
            break

          case 'status':
            for (indexL = 0; indexL < this.linhas.length; indexL++) {
              // SETA O VALOR RECEBIDO
              this.$set(this.linhas[indexL], indexC, value)

              // LIMPA A CHAVE DE MESSAGEM DO CAMPO
              this.$set(this.linhas[indexL], (indexC + '_mensagem'), '')
            }
            break
        }
      },
      // finRegRecDesOnKeyDown: function (indexL, indexC) {
        finRegRecDesOnKeyDown: function (event, indexL, campo, tentativa = 0) {
          if (this.cpntTipo === 'pgto_docfiscal' && event.which === 13 && tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.finRegRecDesOnKeyDown(indexL, campo, (tentativa + 1)) }, 100) }

          // MONTA O NOME DA CHAVE QUE DEVE DAR FOCUS
          var chave = indexL + '--' + campo

          // VERIFICA SE O CAMPO EXISTE
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs[chave]) === -1) {
            // PEGA O ELEMENTO QUE DEVE DAR FOCUS
            var elemento = Array.isArray(this.$refs[chave]) === true ? this.$refs[chave][0] : this.$refs[chave]

            // VERIFICA SE O ELEMENTO EXISTE
            if ([ '', null, undefined ].indexOf(elemento) === -1 && [ '', null, undefined ].indexOf(elemento.cpntRealizarFocus) === -1 && typeof elemento.cpntRealizarFocus === 'function') {
              elemento.cpntRealizarFocus(false)
            } else {
              reiniciar()
            }
          } else {
            reiniciar()
          }
        }
      },
      finRegRecDesOnKeyPressEnter: function (indexL, indexC) {
        switch (this.cpntTipo + '__' + indexC) {
          case 'pgto_docfiscal__inicio':
            this.demEdiProTabItemSetaFocusCampo(indexL, 'valor')
            break

          case 'pgto_docfiscal__valor':
            this.demEdiProTabItemSetaFocusCampo(indexL, 'id_pgto')
            break

          case 'pgto_docfiscal__id_pgto':
            if ([ '03', '3' ].indexOf(this.linhas[indexL].id_pgto.id) !== -1) {
              this.demEdiProTabItemSetaFocusCampo(indexL, 'vcto_pgto')
            } else {
              this.finRegRecDesOnKeyPressEnter(indexL, 'vcto_pgto')
            }
            break

          case 'pgto_docfiscal__vcto_pgto':
            if ((Number(indexL) + 1) >= this.linhas.length) {
              this.finRegRecDesSalvarDados()
            } else {
              this.finRegRecDesOnKeyPressEnter((Number(indexL) + 1), 'inicio')
            }
            break
        }
      },
      finRegRecDesOnChangeValue: function (value, indexL, indexC) {
        // SETA O VALOR RECEBIDO
        // this.$set(this.linhas[indexL], indexC, value)
        this.linhas[indexL][indexC] = value

        // LIMPA A CHAVE DE MESSAGEM DO CAMPO
        this.$set(this.linhas[indexL], (indexC + '_mensagem'), '')

        // VERIFICA SE DEVE FAZER ALGUMA AÇÃO
        switch (indexC) {
          case 'valor':
            this.finRegRecDesSetarValorTotal()
            break

          case 'vcto_soma':
            this.finRegRecDesMontarVencimento(indexL)
            break

          case 'id_pgto':
            if (this.cpntTipo === 'compra' && [ '', null, undefined ].indexOf(value.id_con_pdr_despesa_.id) === -1) {
              this.finRegRecDesOnChangeValue(JSON.parse(JSON.stringify(value.id_con_pdr_despesa_)), indexL, 'id_conta')
            } else if (this.cpntTipo === 'venda' && [ '', null, undefined ].indexOf(value.id_con_pdr_receita_.id) === -1) {
              this.finRegRecDesOnChangeValue(JSON.parse(JSON.stringify(value.id_con_pdr_receita_)), indexL, 'id_conta')
            }
            break

          case 'id_carteira':
            if (value.id === '__NOVO_OPTION__') {
              this.finRegRecDesSalvaCarteira({ nome: value._text }, indexL, (option) => { this.finRegRecDesOnChangeValue(option, indexL, indexC) })
            }
            break
        }

        // LIMPA O VALOR DA REFERENCIA
        this.referencia[indexC] = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      finRegRecDesMontarColunas: function () {
        // INICIA A VARIAVEL
        var remover = []
        var colunas = [
          { mPer: 1,  chave: 'parcela', nome: 'Parcela' },
          { mPer: 1,  chave: 'valor',   nome: 'Valor'             }
        ]
        var nome = ''
        
        // VERIFICA O NOME DA COLUNA CENTRO DE CUSTO
        switch (this.cpntTipo) {
          case 'compra':
            nome = 'Tipo de Despesa'
            break

          case 'venda':
            nome = 'Tipo de Receita'
            break

          case 'pgto_docfiscal':
            remover = [ 'id_conta', 'obs', 'id_carteira', 'status' ]

            colunas = colunas.concat([
              { mPer: 1,  chave: 'id_pgto',       nome: 'Tipo de Pagamento' },
              { mPer: 1,  chave: 'vencimento',    nome: 'Vencimento'        },
            ])
            break
        }
        // VERIFICA SE DEVE ADICIONAR AS COLUNAS
        if (this.cpntTipo !== 'pgto_docfiscal') {
          colunas = colunas.concat([
            { mPer: 1,  chave: 'vencimento',    nome: 'Vencimento'        },
            { mPer: 1,  chave: 'id_pgto',       nome: 'Tipo de Pagamento' }
          ])
        }

        // INICIA A COLUNA
        colunas = colunas.concat([
          { mPer: 1,  chave: 'id_conta',      nome: 'Conta'             },
          { mPer: 1,  chave: 'obs',           nome: 'Observação'        },
          { mPer: 1,  chave: 'id_carteira',   nome: nome                },
          { mPer: 1,  chave: 'status',        nome: 'Status'            }
        ])

        // REMOVE AS COLUNAS QUE NÃO DEVE APRESENTAR
        this.colunas = colunas.filter(item => remover.indexOf(item.chave) === -1)
      },
      finRegRecDesSetarValorInicial: function (callback, camBuscar = null) {
        var option = null
        
        // VERIFICAR SE TEM QUE BUSCAR ALGUMA COISA
        if (camBuscar === null) {
          // VERIFICA OS CAMPOS QUE DEVE BUSCAR
          camBuscar = [ 'id_pgto', 'id_conta', 'id_carteira', 'status' ]

          // REINICIA O PROCESSO DE BUSCA
          this.finRegRecDesSetarValorInicial(callback, camBuscar)
        } else if (camBuscar.length >= 1) {
          // PEGA O NOME DO CAMPO QUE DEVE ATUALIZAR
          var indexF = camBuscar[0]

          // FAZ A BUSCA DOS DADOS
          this.campos[indexF].onBuscarOptions(() => {
            // REMOVE A CHAVE PARA NOVA BUSCA
            camBuscar = camBuscar.filter(item => item !== indexF)

            // REINICIA O PROCESSO DE BUSCA
            setTimeout(() => { this.finRegRecDesSetarValorInicial(callback, camBuscar) }, 0)
          })
        } else if ([ '', null, undefined, '0' ].indexOf(this.demanda.id_rec) === -1) {
          // INICIA A VARIAVEL
          var conta = this.campos.id_conta.options.filter(item => item.id === this.demanda.id_rec.f_pre_id_conta)

          // VERIFICA SE FOI ENCONTRADO ALGUM VALOR
          conta = (conta.length >= 1) ? conta[0] : null

          // INICIA A VARIAVEL
          option = this.campos.id_pgto.options.filter(item => item.id === this.demanda.id_rec.f_pre_id_fp)

          // VERIFICA SE FOI ENCONTRADO ALGUM VALOR
          option = (option.length >= 1) ? option[0] : null

          // SETA O VALOR RECEBIDO
          if (option !== null) {
            // SETA O MEIO DE PAGAMENTO
            this.finRegRecDesOnChangeValueReferencia(option, 'id_pgto')

            // ALTERA A CONTA BANCARIA PARA TODAS AS LINHAS
            if (conta !== null) {
              this.finRegRecDesOnChangeValueReferencia(conta, 'id_conta')
            } else if (this.campos.id_conta.options.length >= 1) {
              if ([ '', null, undefined ].indexOf(option.id_con_pdr_receita_.id) === -1) {
                this.finRegRecDesOnChangeValueReferencia(JSON.parse(JSON.stringify(option.id_con_pdr_receita_)), 'id_conta')
              } else {
                this.finRegRecDesOnChangeValueReferencia(JSON.parse(JSON.stringify(this.campos.id_conta.options[0])), 'id_conta')
              }
            }
          }

          // VERIFICA SE TEM VALOR PARA SETAR
          if ([ '', null, undefined ].indexOf(this.demanda.id_rec.f_pre_id_carteira) === -1) {
            // INICIA A VARIAVEL
            option = this.campos.id_carteira.options.filter(item => item.id === this.demanda.id_rec.f_pre_id_carteira)

            // VERIFICA SE FOI ENCONTRADO ALGUM VALOR
            option = (option.length >= 1) ? option[0] : null

            // SETA O VALOR RECEBIDO
            if (option !== null) {
              this.finRegRecDesOnChangeValueReferencia(option, 'id_carteira')
            }
          }

          // VERIFICA SE TEM VALOR PARA SETAR
          if ([ '', null, undefined ].indexOf(this.demanda.id_rec.f_pre_obs) === -1) {
            this.finRegRecDesOnChangeValueReferencia(this.demanda.id_rec.f_pre_obs, 'obs')
          }
          
          // VERIFICA SE TEM VALOR PARA SETAR
          if ([ '', null, undefined ].indexOf(this.demanda.id_rec.status) === -1) {
            // INICIA A VARIAVEL
            option = this.campos.status.options.filter(item => item.id === this.demanda.id_rec.status)

            // VERIFICA SE FOI ENCONTRADO ALGUM VALOR
            option = (option.length >= 1) ? option[0] : null

            // SETA O VALOR RECEBIDO
            if (option !== null) {
              this.finRegRecDesOnChangeValueReferencia(option, 'status')
            }
          } else {
            this.finRegRecDesOnChangeValueReferencia(this.campos.status.options[0], 'status')
          }

          // EXECUTA O CALLBACK RECEBIDO
          callback()
        } else {
          // INICIA A VARIAVEL
          option = this.campos.id_pgto.options.filter(item => item.id === this.idPgtoIni)

          // VERIFICA SE FOI ENCONTRADO ALGUM VALOR
          option = (option.length >= 1) ? option[0] : null

          // SETA O VALOR RECEBIDO
          if (option !== null) {
            // SETA O MEIO DE PAGAMENTO
            this.finRegRecDesOnChangeValueReferencia(option, 'id_pgto')

            // ALTERA A CONTA BANCARIA PARA TODAS AS LINHAS
            if (this.campos.id_conta.options.length >= 1) {
              if ([ '', null, undefined ].indexOf(option.id_con_pdr_receita_.id) === -1) {
                this.finRegRecDesOnChangeValueReferencia(JSON.parse(JSON.stringify(option.id_con_pdr_receita_)), 'id_conta')
              } else {
                this.finRegRecDesOnChangeValueReferencia(JSON.parse(JSON.stringify(this.campos.id_conta.options[0])), 'id_conta')
              }
            }
          }

          // SETA O MEIO DE PAGAMENTO
          this.finRegRecDesOnChangeValueReferencia(this.campos.status.options[0], 'status')

          // EXECUTA O CALLBACK RECEBIDO
          callback()
        }
      },
      finRegRecDesBuscarMascaraDfPagamento: function (callback) {
        if ([ 'compra', 'venda' ].indexOf(this.cpntTipo) === -1 || this.demanda.status_fin === '1') {
          callback()
        } else {
          // INICIA A VARIAVEL DE ROTA
          var router = ''
          // var chave = ''

          // INICIA A QUERY QUE DEVE REALIZAR
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: {
            id_pgto: { j: { id_con_pdr_receita: null, id_con_pdr_despesa: null } },
            valor: null,
            dup_vcto: null
          } }

          // VERIFICA AS DIFERENÇAS DE DEMANDA
          switch (this.cpntTipo) {
            case 'compra':
              // // SETA A CHAVE DE PAGAMENTO QUE DEVE USAR
              // chave = 'id_con_pdr_despesa'

              // SETA OS CAMPOS ADICIONAIS QUE DEVE BUSCAR
              queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'id_pgto', o: '<>', v: '0' }, { f: 'dem_compra', o: '=', v: this.cpntRefId } ] }

              // SETA A ROTA QUE DEVE CHAMAR
              router = '/demanda/dem-compra/dem-produto/df/pagamento/get'
              break

            case 'venda':
              // // SETA A CHAVE DE PAGAMENTO QUE DEVE USAR
              // chave = 'id_con_pdr_receita'

              // SETA OS CAMPOS ADICIONAIS QUE DEVE BUSCAR
              queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'id_pgto', o: '<>', v: '0' }, { f: 'cod_venda', o: '=', v: this.cpntRefId } ] }

              // SETA A ROTA QUE DEVE CHAMAR
              router = '/venda/produto/df/pagamento/get'
              break
          }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI(router, 'POST', queryGet, (retorno) => {
            // EXECUTA O CALLBACK RECEBIDO
            if (retorno.data.length === 0) {
              callback()
            } else {
              // SETA O NUMERO DE PARCELAS
              this.finRegRecDesOnChangeValueParcela(retorno.data.length.toString(), false, false)

              // INICIA A VARIAVEL
              var option = null
              var soma = 0

              // RODA O FETOR ADICIONANDO OS VALORES
              for (var indexR in retorno.data) {
                // SOMA OS VALORES ENCONTRADOS
                soma += Number(retorno.data[indexR].valor)

                // SETA O VALOR DA PARCELA
                this.finRegRecDesOnChangeValue(retorno.data[indexR].valor, indexR, 'valor')

                // LIMPA O CAMPO DATA SOMA
                this.finRegRecDesOnChangeValue('', indexR, 'vcto_soma')

                // SETA O VENCIMENTO DA PARCELA
                this.finRegRecDesOnChangeValue((retorno.data[indexR].dup_vcto_ptbr !== '' ? retorno.data[indexR].dup_vcto_ptbr : this.demanda.vcto), indexR, 'vcto_pgto')

                // PEGA O TIPO DE PAGAMENTO INFORMADO
                option = this.campos.id_pgto.options.filter(item => item.id === retorno.data[indexR].id_pgto)
                option = option.length >= 1 ? option[0] : this.campos.id_pgto.options[0]
                this.finRegRecDesOnChangeValue(option, indexR, 'id_pgto')

                // // SETA O CENTRO DE CUSTO
                // this.finRegRecDesOnChangeValue(this.campos.id_carteira.options[0], indexR, 'id_carteira')

                // SETA O STATUS DA PARCELA
                option = this.campos.status.options.filter(item => item.id === retorno.data[indexR].status)
                option = option.length >= 1 ? option[0] : this.campos.status.options[0]
                this.finRegRecDesOnChangeValue(option, indexR, 'status')
              }

              // VERIFICA SE TEM DIFERENÇA A SER LANÇADA
              if (soma < Number(this.demanda.virtual_total.geral.liquido) && [ '0', 0 ].indexOf(this.demanda.virtual_total.servico.item) === -1) {
                // SETA O NUMERO DA PARCELA
                var parcela = retorno.data.length

                // CALCULA A DIFERENÇA QUE FALTA
                var diff = Number(this.demanda.virtual_total.geral.liquido) - soma

                // SETA O NUMERO DE PARCELAS
                this.finRegRecDesOnChangeValueParcela((parcela + 1).toString(), false, false)

                // SETA O VALOR DA PARCELA
                this.finRegRecDesOnChangeValue(diff, parcela, 'valor')

                // SETA O VENCIMENTO DA PARCELA
                this.linhas[parcela].vcto_pgto = this.demanda.vcto, parcela
                this.linhas[parcela].vcto_soma = ''
                // this.finRegRecDesOnChangeValue(this.demanda.vcto, parcela, 'vcto_pgto')
                // this.finRegRecDesOnChangeValue('', parcela, 'vcto_soma')

                // PEGA O TIPO DE PAGAMENTO INFORMADO
                option = this.campos.id_pgto.options.filter(item => item.id === this.idPgtoIni)
                option = option.length >= 1 ? option[0] : this.campos.id_pgto.options[0]
                this.finRegRecDesOnChangeValue(option, parcela, 'id_pgto')

                // SETA O STATUS DA PARCELA
                this.finRegRecDesOnChangeValue(this.campos.status.options[0], parcela, 'status')
              }

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()

              // EXECUTA O CALLBACK RECEBIDO
              callback(false)
            }
          }, this.finRegRecDesSetarStatusGeral)
        }
      },
      finRegRecDesBuscarValorReferencia: function (callback) {
        if (this.cpntDemandaDados !== null) {
          // SETA O VALOR RECEBIDO
          this.demanda = this.cpntDemandaDados

          // EXECUTA O CALLBACK
          callback()
        } else if ([ 'compra', 'venda' ].indexOf(this.cpntTipo) === -1) {
          callback()
        } else {
          // INICIA AS VARIAVEIS
          var router = ''

          // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
          const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

          // PEGA A CHAVE REFERENCIA
          var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntTipo)

          // INICIA A QUERY QUE DEVE REALIZAR
          var queryGet = { type: 'list', limit: { row: 0, qty: 1 }, field: { status_fin: null }, field_virtual: [ 'total' ] }

          // SETA O CAMPO QUE DEVE BUSCAR
          queryGet.field[chaveD] = null

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { aAnd: [ { f: chaveD, o: '=', v: this.cpntRefId } ] }

          // VERIFICA AS DIFERENÇAS DE DEMANDA
          switch (this.cpntTipo) {
            case 'compra':
              // SETA OS CAMPOS ADICIONAIS QUE DEVE BUSCAR
              queryGet.field = Object.assign(queryGet.field, { vencimento: { a: 'vcto' } })

              // SETA A ROTA QUE DEVE CHAMAR
              router = '/demanda/dem-compra/get'
              break

            case 'venda':
              // SETA OS CAMPOS ADICIONAIS QUE DEVE BUSCAR
              queryGet.field = Object.assign(queryGet.field, { vencimento: { a: 'vcto' }, id_rec: { j: { f_pre_id_fp: null, f_pre_id_conta: null, f_pre_obs: null, f_pre_id_carteira: null, status: null } } })

              // SETA A ROTA QUE DEVE CHAMAR
              router = '/venda/get'
              break
          }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI(router, 'POST', queryGet, (retorno) => {
            // INICIA O VETOR QUE SERÁ UTILIZADO PARA SALVAR OS DADOS
            var vetor = { vcto: retorno.data[0].vcto }

            // SETA OS CAMPOS A SEREM PREENCHIDOS
            if ([ '', null, undefined, '0' ].indexOf(retorno.data[0].id_rec) === -1) {
              vetor.id_rec = {
                id_rec: retorno.data[0].id_rec,
                f_pre_id_fp: retorno.data[0].id_rec_f_pre_id_fp,
                f_pre_id_conta: retorno.data[0].id_rec_f_pre_id_conta,
                f_pre_obs: retorno.data[0].id_rec_f_pre_obs,
                f_pre_id_carteira: retorno.data[0].id_rec_f_pre_id_carteira,
                status: retorno.data[0].id_rec_status
              }
            }

            // FORMATA O RECEBIMENTO DOS VALORES
            if (this.cpntTipo === 'compra') {
              vetor.virtual_total = { produto: retorno.data[0].virtual_total, geral: retorno.data[0].virtual_total }
            } else if (this.cpntTipo === 'venda') {
              vetor.virtual_total = retorno.data[0].virtual_total
            }

            // SETA OS DADOS SOLICITADOS
            this.demanda = vetor

            // EXECUTA O CALLBACK RECEBIDO
            callback()
          }, this.finRegRecDesSetarStatusGeral)
        }
      },
      
      finRegRecDesSetarValorTotal: function (valorTotal = '') {
        // INICIA O VALOR TOTAL
        valorTotal = valorTotal !== '' ? valorTotal : this.finRegRecDesSomarValoresParcela()

        // SETA O VALOR TOTAL CALCULADO
        this.valorTotal = this.$store.state.FUN_MASK_VALOR('valorMoeda', valorTotal)
      },
      finRegRecDesValorParcelas: function () {
        return (typeof this.parcelas.value === 'string' ? this.parcelas.value : this.parcelas.value.id)
      },
      finRegRecDesMontarLinhas: function (valor = true, vencimento = true) {
        // PEGA O NUMERO DE PARCELAS
        var parcelas = Number(this.finRegRecDesValorParcelas())

        // PEGA O NUMERO DE LINHAS JÁ EXISTENTES
        var qtdeExistente = this.linhas.length

        // CALCULA A QUANTIDADE DE LINHAS FALTANTES
        var falta = (parcelas - qtdeExistente)

        // VERIFICA SE DEVE ADICIONAR OU REMOVER LINHAS DA TABELA
        if (falta >= 1) {
          for (var par = 1; par <= falta; par++) {
            // INICIA A VARIAVEL COM A LINHA
            var linha = {}
  
            // SETA O NUMERO DA PARCELA
            linha.parcela = (qtdeExistente + par).toString()

            // INICIA A VARIAVEL VALOR
            linha.valor = '0'
            linha.valor_mensagem = ''

            // INICIA A VARIAVEL VENCIMENTO
            linha.vcto_soma = (linha.parcela === '1' ? '0' : '7')
            linha.vcto_pgto = ''
            linha.vcto_pgto_mensagem = ''

            // INICIA A VARIAVEL DE PAGAMENTO
            linha.id_pgto = this.referencia.id_pgto
            linha.id_pgto_mensagem = ''

            // INICIA A VARIAVEL DE CONTA
            linha.id_conta = this.referencia.id_conta
            linha.id_conta_mensagem = ''

            // INICIA A VARIAVEL DE OBSERVAÇÃO
            linha.obs = this.referencia.obs
            linha.obs_mensagem = ''

            // INICIA A VARIAVEL DE CENTRO DE CUSTO
            linha.id_carteira = this.referencia.id_carteira
            linha.id_carteira_mensagem = ''

            // INICIA A VARIAVEL DE STATUS
            linha.status = this.referencia.status 
            linha.status_mensagem = ''
            //(this.referencia.status !== '' && this.referencia.status.id !== '') ? this.referencia.status : this.campos.status.options[0]
  
            // ADICIONA A LINHA A TABELA
            this.linhas.push(linha)
          }
        } else {
          // VERIFICA A QTDE DE LINHAS QUE DEVE REMOVER
          var remover = falta * (-1)

          // REMOVE AS LINHAS SOLICITADAS
          this.linhas.splice((this.linhas.length - remover), remover)
        }

        // CHAMA A FUNÇÃO PARA MONTAR O VALOR DAS LINHAS
        if (valor === true) {
          this.finRegRecDesMontarValorParcela()
        }

        // CHAMA A FUNÇÃO PARA MONTAR O VENCIMENTO DAS LINHAS
        if (vencimento === true) {
          this.finRegRecDesMontarVencimento()
        }
      },
      finRegRecDesPegarValorReferencia: function (indexC) {
        // INICIA O VALOR 
        var valor = ''
        
        // VERIFICA O CAMPO QUE ESTÁ PEGANDO O VALOR
        switch (indexC) {
          case 'valor':
            // PEGA O VALOR ENCONTRADO
            valor = this.referencia.valor

            // VERIFICA SE NÃO É UM NUMERO
            if (isNaN(valor) === false) {
              // REMOVE OS PONTOS DA STRING
              while (valor.indexOf('.') > -1) {
                valor = valor.replace('.', '')
              }
  
              // REMOVE OS VIRGULA DA STRING
              valor = valor.replace(',', '')
            }
            break

          case 'valor_tipo':
          case 'vcto_tipo':
            valor = (typeof this.referencia[indexC] === 'string' ? this.referencia[indexC] : this.referencia[indexC].id)
            break

          default:
            valor = this.referencia[indexC]
            break
        }

        // RETORNA O VALOR ENCONTRADO
        return valor
      },
      finRegRecDesSomarValoresParcela: function () {
        // INICIA O VALOR TOTAL
        var valorTotal = 0

        // RODA UM FOR ATUALIZANDO OS VALORES
        for (var indexL in this.linhas) {
          valorTotal += Number(this.linhas[indexL].valor)
        }

        // RETORNA O VALOR MONTADO
        return valorTotal
      },
      finRegRecDesMontarValorParcela: function (valorP = '') {
        // PEGA O VALOR LIQUIDO DA VENDA
        var valor = Number(this.finRegRecDesPegarValorReferencia('valor'))

        // PEGA O TIPO DE ATUALIZAÇÃO
        var tipo = this.finRegRecDesPegarValorReferencia('valor_tipo')

        // VERIFICA SE TEM VALOR DE PARCELA A SER SETADO
        if (valorP === '') {
          if (tipo === 'D') {
            // PEGA O NUMERO DE PARCELAS
            var parcelas = Number(this.finRegRecDesValorParcelas())
    
            // CALCULA O VALOR DE CADA PARCELA
            valorP = (valor / parcelas)
  
            // ARREDONDA O VALOR
            valorP = Math.ceil(valorP)
          } else {
            valorP = valor
          }
        }

        // RODA UM FOR ATUALIZANDO OS VALORES
        for (var indexL in this.linhas) {
          this.linhas[indexL].valor = valorP.toString()
        }

        // INICIA O VALOR TOTAL
        var valorTotal = this.finRegRecDesSomarValoresParcela()

        // VERIFICA SE DEVE AJUSTAR O VALOR
        if (tipo === 'D') {
          // CALCULA A DIFERENÇA ENCONTRADA
          var diferenca = valor - valorTotal
  
          // VERIFICA SE DEU SOMA DIFERENTE DO VALOR ESPERADO
          if (diferenca !== 0) {
            // CORRIGE O VALOR DA PARCELA 1
            this.linhas[0].valor = (Number(this.linhas[indexL].valor) + diferenca).toString()
  
            // CORRIGE O VALOR TOTAL
            valorTotal = (valorTotal + diferenca)
          }
        }

        // CHAMA A FUNÇÃO PARA SETAR O VALOR TOTAL
        this.finRegRecDesSetarValorTotal(valorTotal)
      },
      finRegRecDesMontarVencimento: function (indexLI = 0) {
        // CONVERTE O VALOR RECEBIDO EM NUMERO
        indexLI = Number(indexLI)

        // PEGA O TIPO DE ATUALIZAÇÃO
        var tipo = this.finRegRecDesPegarValorReferencia('vcto_tipo')

        // INICIA AS VARIAVEIS
        var dataRef = ''
        var soma = ''
        var indexA = ''

        // RODA O VETOR ATUALIZANDO OS VALORES
        for (var indexL = indexLI; indexL < this.linhas.length; indexL++) {
          if (tipo === 'S') {
            // PEGA O ID DA LINHA ANTERIOR
            indexA = Number(indexL) - 1
            
            // PEGA O VALOR DA DATA REFERENCIA
            if (indexL === 0) {
              dataRef = this.finRegRecDesPegarValorReferencia('vcto_pgto')
            } else {
              dataRef = this.linhas[indexA].vcto_pgto
            }

            // PEGA O NUMERO DE DIAS QUE DEVE SOMAR
            soma = Number(this.linhas[indexL].vcto_soma)
    
            // SOMA AS DATA REFERENCIA + O NUMERO DE DIAS DIGITANDO NO CAMPO AO LADO
            this.linhas[indexL].vcto_pgto = moment(dataRef, 'DD/MM/YYYY').add(soma, 'd').format('DD/MM/YYYY')
          } else if (tipo === 'D') {
            // PEGA O VALOR DA DATA REFERENCIA
            dataRef = this.finRegRecDesPegarValorReferencia('vcto_pgto')
            
            // SETA A DATA DE REFERENCIA
            if (indexL === 0) {
              this.linhas[indexL].vcto_pgto = dataRef
            } else {
              // CALCULA A QUANTIDADE DE MESES QUE DEVE SOMAR
              soma = (indexL === 0 ? 1 : (Number(soma) + 1))
              
              // SETA A DATA ATUALIZADA NO CAMPO
              this.linhas[indexL].vcto_pgto = moment(dataRef, 'DD/MM/YYYY').add(soma, 'M').format('DD/MM/YYYY')
            }
          } else if (tipo === 'C') {
            this.linhas[indexL].vcto_pgto = this.finRegRecDesPegarValorReferencia('vcto_pgto')
          }
        }
      },
      finRegRecDesBuscarTipoPagamento: function (callback, indexL, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // INICIA A VARIAVEL QUERYGET
          var queryGet = null
          var router = null
          var method = null

          // SETA A ROTA QUE DEVE CHEMAR
          router = '/financeiro/config/for-pagamento/get'

          // SETA O METHOD DA ROTA
          method = 'POST'

          // MONTA O QUERY GET
          queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, order: { nome: 'asc' } }

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = { id: null, nome: null }

          // SETA OS CAMPOS QUE DEVE BUSCAR
          queryGet.field.id_con_pdr_despesa = { j: { id: null, tp_conta: null, id_banco: null, agencia: null, agencia_dv: null, conta: null, conta_dv: null } }

          // SETA OS CAMPOS QUE DEVE BUSCAR
          queryGet.field.id_con_pdr_receita = { j: { id: null, tp_conta: null, id_banco: null, agencia: null, agencia_dv: null, conta: null, conta_dv: null } }

          // REMOVE PAGAMENTOS OUTROS
          if (this.cpntTipo === 'pgto_docfiscal') {
            queryGet.where = { f: 'id_pgto_df', o: '<>', v: '99' }
          }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI(router, method, queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.finRegRecDesBuscarTipoPagamento(callback, indexL, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.id_pgto.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campos.id_pgto.onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // TRATA OS REGISTROS RECEBIDOS
          registros = this.finRegRecDesTratarRegistrosContaBancaria(registros)

          // SETA OS VALORES RECEBIDOS
          this.campos.id_pgto.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      finRegRecDesTratarContaBancaria: function (dados, indexC = '') {
        // VERIFICA SE TEM QUE ADICIONA O NOME NA FRENTE
        if (indexC !== '') {
          indexC = 'id_con_pdr_' + indexC + '_'
        }

        // INICIA A VARIAVEL COM O NOME
        dados[indexC + 'nome'] = ''

        // MONTA O NOME DO BANCO A SER MOSTRADO
        if ([ '1' ].indexOf(dados[indexC + 'id']) !== -1) {
          dados[indexC + 'nome'] = dados[indexC + 'id_banco']
        } else {
          // INICIA A VARIAVEL PARA O CAMINHO DO ICONE DO BANCO
          dados[indexC + '_img'] = '/img/banco/' + dados[indexC + 'id_banco'] + '.png'

          // ADICIONA O NUMERO DA AGENCIA
          if ([ '', null, undefined ].indexOf(dados[indexC + 'agencia']) === -1) {
            // SETA O NUMERO DA AGENCIA
            dados[indexC + 'nome'] = 'AG.' + dados[indexC + 'agencia']

            // SETA O DIGITO DA AGENCIA
            if ([ '', null, undefined ].indexOf(dados[indexC + 'agencia_dv']) === -1) {
              dados[indexC + 'nome'] += '-' + dados[indexC + 'agencia_dv']
            }
          }
          
          // ADICIONA O NUMERO DA CONTA
          if ([ '', null, undefined ].indexOf(dados[indexC + 'conta']) === -1) {
            // SETA A INICIAL DA CONTA
            dados[indexC + 'nome'] += ' C'

            // SETA O TIPO DA CONTA
            switch (dados[indexC + 'tp_conta']) {
              case '1':
                dados[indexC + 'nome'] += 'C'
                break

              case '2':
                dados[indexC + 'nome'] += 'P'
                break
            }

            // FINALIZA O NOME DA CONTA
            dados[indexC + 'nome'] += '.' + dados[indexC + 'conta']

            // SETA O DIGITO DA CONTA
            if ([ '', null, undefined ].indexOf(dados[indexC + 'conta_dv']) === -1) {
              dados[indexC + 'nome'] += '-' + dados[indexC + 'conta_dv']
            }
          }
        }

        // INICIA O VETOR
        var vetor = {}

        // VERIFICA SE TEM JOIN INFORMADO
        if (indexC !== '') {
          for (var index in dados) {
            if (index.indexOf(indexC) !== -1) {
              // INICIA A VARIAVEL SE NÃO EXISTIR
              if (vetor[indexC] === undefined) {
                vetor[indexC] = {}
              }

              // PEGA O NOME DA NOVA CHAVE
              var chave = index.replace(indexC, '')
  
              // ADICIONA O NOVO VALOR AO VETOR
              vetor[indexC][chave] = dados[index]
            } else if (index.indexOf('id_con_pdr_') === -1) {
              vetor[index] = dados[index]
            }
          }
        } else {
          vetor = dados
        }

        // RETORNA O VALOR MONTADO
        return vetor
      },
      finRegRecDesTratarRegistrosContaBancaria: function (vetor) {
        // MONTA O VETOR PARA RETORNAR
        var retorno = []

        // TRATA OS VALORES RECEBIDOS
        for (var indexR in vetor) {
          // PEGA O VALOR RECEBIDO
          var item = {}

          // VETOR ADICIONAL PARA RETORNO
          item = Object.assign(item, this.finRegRecDesTratarContaBancaria(JSON.parse(JSON.stringify(vetor[indexR])), 'receita'))

          // VETOR ADICIONAL PARA RETORNO
          item = Object.assign(item, this.finRegRecDesTratarContaBancaria(JSON.parse(JSON.stringify(vetor[indexR])), 'despesa'))

          // ADICOINA O VALOR MONTADO
          retorno.push(item)
        }

        // RETORNA O VALOR MONTADO
        return retorno
      },
      finRegRecDesBuscarContaBancaria: function (callback, total = null, registros = []) {
        if (this.cpntTipo !== 'pgto_docfiscal') {
          if (total === null || total < registros.length) {
            // MONTA O QUERY GET
            var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

            // SETA OS CAMPOS QUE DEVEJA 
            queryGet.field = { id: null, tp_conta: null, id_banco: null, agencia: null, agencia_dv: null, conta: null, conta_dv: null }

            // SETA O WHERE QUE DEVE REALIZAR
            queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }

            // FAZ A BUSCA DOS DADOS
            this.$store.state.comunicaAPI('/financeiro/config/conta/get/', 'GET', queryGet, (apiSuccess) => {
              // JUNTA OS VALORES RECEBIDOS
              registros = registros.concat(apiSuccess.data)

              // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
              this.finRegRecDesBuscarContaBancaria(callback, Number(apiSuccess.countAll), registros)
            }, (apiError) => {
              // SETA OS VALORES RECEBIDOS
              this.campos.id_conta.status = apiError

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          } else if (total === 0) {
            // SETA OS VALORES RECEBIDOS
            this.campos.id_conta.onBuscarOptions = null

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // EXECUTA A FUNÇÃO CALLBACK
            callback()
          } else {
            // TRATA OS VALORES RECEBIDOS
            for (var indexR in registros) {
              registros[indexR] = this.finRegRecDesTratarContaBancaria(JSON.parse(JSON.stringify(registros[indexR])), '')
            }

            // SETA OS VALORES RECEBIDOS
            this.campos.id_conta.options = registros

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // EXECUTA A FUNÇÃO CALLBACK
            callback()
          }
        } else {
          callback()
        }
      },
      finRegRecDesBuscarCentroDeCusto: function (callback, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // INICIA A VARIAVEL
          var router = ''
          var method = ''

          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, order: { nome: 'asc' } }

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = { id: null, nome: null }

          // SETA O WHERE
          queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }

          // VERIFICA AS DIFERENÇAS DE DEMANDA
          switch (this.cpntTipo) {
            case 'compra':
              // SETA A ROTA QUE DEVE CHAMAR
              router = '/financeiro/config/car-despesa/get'

              // SETA O METHOD QUE DEVE USAR
              method = 'POST'
              break

            case 'venda':
              // SETA A ROTA QUE DEVE CHAMAR
              router = '/financeiro/config/car-receita/get/'

              // SETA O METHOD QUE DEVE USAR
              method = 'GET'
              break
          }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI(router, method, queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.finRegRecDesBuscarCentroDeCusto(callback, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.id_carteira.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campos.id_carteira.onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.id_carteira.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      finRegRecDesBuscarStatus: function (callback) {
        // INICIA O VETOR
        var registros = []
        
        // VERIFICA AS DIFERENÇAS DE DEMANDA
        switch (this.cpntTipo) {
          case 'compra':
            registros = [
              { id: '1', nome: 'A Pagar' },
              { id: '2', nome: 'Pago' }
            ]
            break

          case 'venda':
            registros = [
              { id: '1', nome: 'A Receber' },
              { id: '2', nome: 'Recebido' }
            ]
            break
        }

        // SETA OS VALORES RECEBIDOS
        this.campos.status.options = registros

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // EXECUTA A FUNÇÃO CALLBACK
        callback()
      },
      finRegRecDesAdicionarNovaConta: function (indexL) {
        // INICIA A VARIAVEL COM OS PARAMETROS
        var params = { tipo: 'id_conta', id: 0 }

        // SETA A FUNÇÃO CALLBACK QUE DEVE USAR
        params.callback = (atualizar, id, dados) => {
          // SETA OS DADOS NO CAMPO
          this.extra = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // MANDA A ATUALIZAR O CAMPO
          if (atualizar === true) {
            // LIMPA AS OPÇÕES SELECIONADAS NO CAMPO
            this.campos.id_conta.options = []

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // SETA O VALOR RECEBIDO NOS CAMPOS
            setTimeout(() => {
              if (indexL === 'referencia') {
                this.finRegRecDesOnChangeValueReferencia(dados, 'id_conta')
              } else {
                this.finRegRecDesOnChangeValue(dados, indexL, 'id_conta')
              }
            }, 100)
          }
        }

        // SETA OS DADOS NO CAMPO
        this.extra = params

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      finRegRecDesSalvaCarteira: function (formData, indexL, callback) {
        // INICIA A ROTA QUE DEVE CHAMAR
        var router = ''

        // SETA O MODULO QUE ESTÁ GERANDO ESSA INFORMAÇÃO
        switch (this.cpntTipo) {
          case 'compra':
            router = '/financeiro/config/car-despesa'
            break

          case 'venda':
            router = '/financeiro/config/car-receita'
            break
        }

        // FAZ A BUSCA DOS DADOS
        this.$store.state.comunicaAPI(router, 'POST', formData, (retorno) => {
          // APRESENTA A MENSAGEM DE SUCESSO
          this.$store.state.TRATAR_RET_LOT_API(retorno)

          // VERIFICA SE FOI SALVO O REGISTRO
          if ([ '', null, undefined ].indexOf(retorno.ref) === -1 && [ '', null, undefined ].indexOf(retorno.ref.id) === -1) {
            // SETA OS VALORES RECEBIDOS
            this.campos.id_carteira.options = []

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // RETORNA O VALOR
            callback({ id: retorno.ref.id, nome: formData.nome })
          } else {
            callback(null)
          }
        }, this.finRegRecDesSetarStatusGeral, (apiValid) => {
          // TRATA A MENSAGEM RECEBIDA
          if ([ '', null, undefined ].indexOf(apiValid.nome) === -1) {
            apiValid = (typeof apiValid.nome === 'object' && Array.isArray(apiValid.nome) === true ? apiValid.nome.join() : apiValid.nome)
          }

          // ADICIONA A MENSAGEM DE ERRO NA TELA
          this.linhas[indexL].id_carteira_mensagem = apiValid

          // SETA O FOCUS NO CAMPO SOLICITADO
          this.demEdiProTabItemSetaFocusCampo(indexL, 'id_carteira')

          // SETA OS DADOS NO CAMPO
          this.extra = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        })
      },
      finRegRecDesSalvaCarteiraEnvio: function (vetor, _formData, callback) {
        if (vetor.length === 0) {
          callback(_formData)
        } else {
          this.finRegRecDesSalvaCarteira(JSON.parse(JSON.stringify(vetor[0])), (option) => {
            // VERIFICA SE FOI SALVO O REGISTRO
            if ([ '', null, undefined ].indexOf(option) === -1) {
              for (var indexP in _formData.parcela) {
                if (_formData.parcela[indexP].id_carteira === option.nome) {
                  // ADICIONA O VALOR NO SELETOR
                  this.linhas[indexP].id_carteira = option

                  // SETA OS VALORES RECEBIDOS
                  this.campos.id_carteira.options = []                 

                  // ATUALIZA O VALOR NO FORMULARIO QUE SERÁ ENVIADO PARA API
                  _formData.parcela[indexP].id_carteira = option.id
                }
              }
            }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // REMOVE O VALOR TRABALHADO
            vetor = vetor.splice(1, 1)

            // REINICIA O PROCESSO
            this.finRegRecDesSalvaCarteiraEnvio(vetor, _formData, callback)
          })
        }
      },
      finRegRecDesSetarStatusBotao: function (status) {
        // SETA OS DADOS NO CAMPO
        this.extra = status
  
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      finRegRecDesSalvarDados: function () {
        // SETA O STATUS DO BOTÃO
        this.finRegRecDesSetarStatusBotao('carregando')

        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }
        
        // INICIA O FORMULARIO QUE SERÁ ENVIADO PARA API
        var formData = { ref: {}, parcela: [] }

        // SETA O MODULO QUE ESTÁ GERANDO ESSA INFORMAÇÃO
        switch (this.cpntTipo) {
          case 'compra':
            formData.ref.modulo = 'dem_compra'
            break

          case 'venda':
            formData.ref.modulo = 'venda'
            break
        }

        // INICIA O VETOR DE CARTEIRA
        var carteira = []
        
        // SETA O ID DA COMPRA/VENDA
        formData.ref.id_mod_reg = this.cpntRefId.toString()

        // RODA O VETOR MONTANDO AS PARCELAS
        for (var indexL in this.linhas) {
          // INICIA O VALOR DA PARCELA
          var parcela = {}

          // Informe o valor da parcela sem pontos e virgulas. Ex: 100,00 -> 10000
          parcela.valor = this.linhas[indexL].valor
          
          // Vencimento / Pagamento, informe na data portugues / brasil Ex: 21/03/2018
          parcela.vcto_pgto = this.linhas[indexL].vcto_pgto
          
          // Informe o id da forma de pagamento.
          parcela.id_pgto = (typeof this.linhas[indexL].id_pgto === 'string' ? this.linhas[indexL].id_pgto : this.linhas[indexL].id_pgto.id)

          // VERIFICA O TIPO DE REGISTRO QUE ESTÁ SENDO INSERIDO
          if (this.cpntTipo !== 'pgto_docfiscal') {
            // Informe o id da conta bancária.
            parcela.id_conta = (typeof this.linhas[indexL].id_conta === 'string' ? this.linhas[indexL].id_conta : this.linhas[indexL].id_conta.id)
                      
            // Informe uma observação.
            parcela.obs = this.linhas[indexL].obs
            
            // Informe o id da carteira de receita ou da carteira de despesa
            parcela.id_carteira = (typeof this.linhas[indexL].id_carteira === 'string' ? this.linhas[indexL].id_carteira : this.linhas[indexL].id_carteira.id)
  
            // VERIFICA SE DEVE INSERIR UMA NOVA CARTEIRA
            if (parcela.id_carteira === '__NOVO_OPTION__') {
              // SETA O VALOR PARA SER ENCONTRADO DEPOIS QUE SALVAR
              parcela.id_carteira = this.linhas[indexL].id_carteira._text
  
              // ADICIONA UMA CARTEIRA A SER SALVA
              carteira.push({ nome: this.linhas[indexL].id_carteira._text, descricao: '' })
            }
            
            // Informe o status da parcela - 1 A Receber, 2 - Recebido
            parcela.status = (typeof this.linhas[indexL].status === 'string' ? this.linhas[indexL].status : this.linhas[indexL].status.id)
          }

          // ADICIONA A PARCELA AO VETOR DE DADOS
          formData.parcela.push(parcela)
        }
        // CHAMA A FUNÇÃO PARA SALVAR OS DADOS
        this.cpntOnSalvarDados(formData, (__formData) => {
          this.finRegRecDesSalvaCarteiraEnvio(carteira, __formData, (_formData) => {
            // CONVERTE O FORMULARIO EM LOT
            _formData = { lot: [ _formData ] }
            
            // FAZ A BUSCA DOS DADOS
            this.$store.state.comunicaAPI('/financeiro', 'POST', _formData, (retorno) => {
              // PEGA O RETORNO RECEBIDO
              retorno = retorno.lot[0]
  
              // INICIA A VARIAVEL
              var focus = null
    
              // VERIFICA O CODIGO DE RETORNO
              if (retorno.code !== '200') {
                // VERIFICA O TIPO DE ERRO RECEBIDO
                if (typeof retorno.message === 'string' || Array.isArray(retorno.message) === true) {
                  // CARREGA AM ENSAGEM RECEBIDA
                  retorno.message = (typeof retorno.message === 'object' && Array.isArray(retorno.message) === true ? retorno.message.join() : retorno.message)
    
                  // SETA A MENSAGEM DE ERRO RECEBIDA
                  this.$store.state.msgWarn('API [' + retorno.code + ']: ' + retorno.message, 'danger')
                } else {
                  // RODA O FOR PROCURANDO AS INFORMAÇOES
                  for (var indexM in retorno.message) {
                    // PEGA AS CHAVES 
                    var index = indexM.split('.')
    
                    // TRATA A MENSAGEM RECEBIDA
                    retorno.message[indexM] = (typeof retorno.message[indexM] === 'object' && Array.isArray(retorno.message[indexM]) === true ? retorno.message[indexM].join() : retorno.message[indexM])
    
                    // VERIFICA SE EXISTE CAMPO PARA MENSAGEM
                    if (this.linhas[index[0]][index[1] + '_mensagem'] !== undefined) {
                      // SETA A MENSAGEM RECEBIDA
                      this.linhas[index[0]][index[1] + '_mensagem'] = retorno.message[indexM]
  
                      // SETA O CAMPO QUE DEVE RECEBER O FOCUS
                      if (focus === null) {
                        focus = { indexL: index[0], indexC: index[1] }
                      }
                    } else {
                      this.$store.state.msgWarn('API [' + retorno.code + ']: ' + retorno.message[indexM], 'danger')
                    }
                  }
                }
  
                // SETA O FOCUS NO CAMPO SOLICITADO
                if (focus !== null) {
                  this.demEdiProTabItemSetaFocusCampo(focus.indexL, focus.indexC)
                }
    
                // SETA OS DADOS NO CAMPO
                this.extra = ''
    
                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
              } else {
                // APRESENTA A MENSAGEM RECEBIDA AO USUARIO
                this.$store.state.TRATAR_RET_LOT_API(retorno, null)
  
                // MANDA ATUALIZAR AS INFORMAÇÕES DO MENU
                this.$store.commit('SET_INFO_MENU')
    
                // EXECUTA A FUNÇÃO PARA ATUALIZAR OS DADOS DA TELA
                this.cpntOnAtualizaDados()
              }
            }, this.finRegRecDesSetarStatusGeral)
          })
        }, this.finRegRecDesSetarStatusBotao)
      }
    }
  }
</script>

